import {
    Box, Table, TableBody, TableCell, Button,
    Paper,
    TableContainer, TableHead, TableRow, Typography, TextField,
    Grid2, Popover,
    Snackbar, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
    Avatar,
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Switch,
    FormControlLabel,
    FormGroup,
    IconButton,
    Menu,
    ListItemText,
    Modal,
    Stack,
    Chip,
    InputAdornment,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Divider,
    Tooltip,
} from "@mui/material";
import React, { useState, useEffect, useRef, useMemo } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditHamIcon from '../../assets/icons/Action_Button.svg';
import EditIcon from '@mui/icons-material/Edit';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '../../assets/icons/ArrowDown.svg';
import CheckIcon from '@mui/icons-material/Check';
import { Label } from "flowbite-react";
import { DateCalendar, DatePicker, DateTimePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import altProfile from '../../assets/images/altProfile.png';
import MagnifierIcon from '../../assets/icons/Magnifier.svg';
import EditPencil from '../../assets/icons/EditPencil.svg';
import EditSvg from '../../assets/icons/blueedit.svg';
import ViewIcon from '../../assets/icons/eye1.svg';
import config from "../../config/config";
import ActionbuttonSvg from "../../assets/icons/Action Button.svg";
import { Title } from "@mui/icons-material";
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc";
import { Navigate, useNavigate } from "react-router-dom";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo/DemoContainer";
import DirectionsCarIcon from "../../assets/icons/Request.svg";
import TokenError from "../tokenError";
import Trash from "../../assets/icons/Trash.svg";
import PickUpIcon from '../../assets/icons/PickupIcon.svg';
import DropIcon from '../../assets/icons/DropIcon.svg';
import BlueCarIcon from '../../assets/icons/blueCar.svg';
import {VehicleTypes} from '../../constant';
import {taxiEngagementStatus} from '../../constant';
import { border } from "@mui/system";
const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#1890ff',
                ...theme.applyStyles('dark', {
                    backgroundColor: '#177ddc',
                }),
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
        ...theme.applyStyles('dark', {
            backgroundColor: 'rgba(255,255,255,.35)',
        }),
    },
}));

const ColoredLine = ({ color }) => (
    <hr
        style={{
            color: color,
            width: '2%',
            backgroundColor: color,
            borderRadius: '5px',
            height: 60
        }}
    />
);

const ShiftTiming = () => {
    const [dateFilter, setDateFilter] = useState(dayjs());
    const [dummydata, setDummydata] = useState({ data: {} }); // your shifts data by date
    const [copiedData, setCopiedData] = useState(null);      // holds copied shifts
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [previousDate, setPreviousDate] = useState(dayjs());
    const [showPasteDialog, setShowPasteDialog] = useState(false);
    const [errorDialog, setErrorDialog] = useState(false);
    const [pendingPasteDate, setPendingPasteDate] = useState('');
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [status, setStatus] = useState(false);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openViewModal, setopenViewModal] = useState(false);
    const [drivers, setDrivers] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [mainselectedDate, setMainselectedDate] = useState(dayjs());
    const date = mainselectedDate.format('YYYY-MM-DD');
    const [vehicleId, setVehicleId] = useState('');
    const [openModal, setOpenModal] = React.useState(false);
    const [maineditclick, setmaineditclick] = useState(null);
    const [noDriverMessage, setNoDriverMessage] = useState('');
    const [driversData, setDriversData] = useState([]);
    const [modalEditDetails, setModalEditDetails] = useState([]);
    const [modalDriverDetails, setModalDriverDetails] = useState([]);
    const [editingShiftIndex, setEditingShiftIndex] = useState(null);
    const [driver, setDriver] = useState('');
    const [availableVehicle, setAvailableVehicle] = useState([]);
    const [modalVehicle, setModalVehicle] = useState('');
    const [modalDriver, setModalDriver] = useState('');
    const [modalStartTime, setModalStartTime] = useState(null);
    const [modalEndTime, setModalEndTime] = useState(null);
    const [editDetails, setEditDetails] = useState(null);
    const navigate = useNavigate();
    const [editableShifts, setEditableShifts] = useState([]);
    const [returnDateError, setReturnDateError] = useState(false);
    const [dateTimeError, setDateTimeError] = useState('');
    const [dateTime, setDateTime] = useState(dayjs());
    const [endDateTime, setEndDateTime] = useState(dayjs());
    const [newendDateTime, setNewEndDateTime] = useState(dayjs());
    const [shiftType, setShiftType] = useState('');
    const [showAddShiftForm, setShowAddShiftForm] = useState(false);
    const [newShiftCounter, setNewShiftCounter] = useState(0);
    const [editingShiftId, setEditingShiftId] = useState(null);
    const [vehicleMenu, setVehicleMenu] = useState({ anchor: null, index: null });
    const [suppressVehicleMenuOpen, setSuppressVehicleMenuOpen] = useState(false);
    const fetchRef = useRef(null);
    const [copiedShifts, setCopiedShifts] = useState(null);
    const [pasteDate, setPasteDate] = useState(dayjs());
    const [copyDate, setCopyDate] = useState('');
    const [dayshift, setDayShift] = useState('');
    const [isPasting, setIsPasting] = useState(false);
    const skipFetchRef = useRef(false);
    const [newShiftDriverId, setNewShiftDriverId] = useState('');
    const [selectedShift, setSelectedShift] = useState(null);
    const [deletingShiftId, setDeletingShiftId] = useState(null);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
    const [singleShiftModal, setSingleShiftModal] = useState(false);
    const [singleShiftId, setSingleShiftId] = useState(null);
    const [openOverWriteModal, setOpenOverWriteModal] = useState(false);
    const [overridestatus,setOverridestatus] = useState(false);
    const [ShiftRideDetails,setShiftRideDetails] = useState([]);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [emptystatus,setEmptystatus] = useState(false);
    const [errordialogeMessage, seterrordialogeMessage] = useState('');
    const tomorrow = dayjs().add(1, 'day');
    const today = dayjs();
    const currentRoleId = localStorage.getItem('client_role_id');

    const currentselectedDate = mainselectedDate ? dayjs(mainselectedDate) : dayjs();


    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';


    useEffect(() => {
        if (editDetails?.shift_timing) {
            setEditableShifts([...editDetails.shift_timing]);
        }
    }, [editDetails]);

    const [newShift, setNewShift] = useState({
        start_time: '',
        end_time: '',
        vehicle_number: '',
        driver_id: ''
    });

    const handleAddNewShift = () => {
        setShowAddShiftForm(true);
        setNewShiftCounter(prev => prev === 0 ? 1 : prev + 1);
        const currentDate = mainselectedDate ? dayjs(mainselectedDate) : dayjs();
        setDateTime(currentDate);
        setEndDateTime(currentDate.add(1, 'hour')); 
       const driverForNew = newShiftDriverId || editDetails?.driver_id || modalDriverDetails?.driver_id || null;
        setNewShift({
            start_time: '',
            end_time: '',
            vehicle_number: '',
            driver_id: driverForNew,
            driver_name: drivers.find(driver => String(driver.driver_id) === String(driverForNew))?.driver_name || ''
        });
    };


    const handlemodalOpen = (shift, driver,index) => {
        setOpenModal(true);
        setModalEditDetails(shift);
        setModalDriverDetails(driver);
        setEditingShiftIndex(index);
        setEditingShiftId(shift.shift_id);
        setModalVehicle(shift.id?.toString() || '');
        setModalStartTime(shift?.start ? dayjs(shift.start) : null);
        setModalEndTime(shift?.end ? dayjs(shift.end) : null);
        if(driver?.driver_id){
            setNewShiftDriverId(driver.driver_id);
        }else if(shift?.driver_id){
            setNewShiftDriverId(shift.driver_id);
        }
    };


    // const handleNewShiftChange = (field, value) => {
    //     setNewShift(prev => {
    //         const updated = {
    //             ...prev,  // This spreads all existing state
    //             [field]: value
    //         };
    //         return updated;
    //     });
    // };
//     const handleNewShiftChange = (field, value) => {
//     setNewShift(prev => {
//         let updatedValue = value;

//         // Apply UTC offset only for start_time or end_time
//         if (field === 'start_time' || field === 'end_time') {
//             const utcOffsetVal = parseInt(localStorage.getItem('utc_offset') || '240', 10);
//             // Add the offset and format as "YYYY-MM-DD HH:mm:ss"
//             updatedValue = dayjs(value).add(utcOffsetVal, 'minute').format('YYYY-MM-DD HH:mm:ss');
//         }

//         return {
//             ...prev,
//             [field]: updatedValue
//         };
//     });
// };

const handleNewShiftChange = (field, value) => {
    setNewShift(prev => {
        const utcOffsetVal = parseInt(localStorage.getItem('utc_offset') || '240', 10);
        let updatedValue = value;

        if (field === 'start_time') {
            const startDateTime = dayjs(value).add(utcOffsetVal, 'minute');
            updatedValue = startDateTime.format('YYYY-MM-DD HH:mm:ss');
            
            // Update end time to maintain the same date as start time if needed
            if (prev.end_time) {
                const currentEnd = dayjs(prev.end_time);
                const newEndDateTime = startDateTime
                    .hour(currentEnd.hour())
                    .minute(currentEnd.minute())
                    .second(currentEnd.second());
                setEndDateTime(newEndDateTime);
            }
        }
        else if (field === 'end_time') {
            // If there's a start time, use its date for the end time
            const startTime = prev.start_time ? dayjs(prev.start_time) : dayjs();
            const timeOnly = dayjs(value);
            const newEndDateTime = startTime
                .hour(timeOnly.hour())
                .minute(timeOnly.minute())
                .second(timeOnly.second())
                .add(utcOffsetVal, 'minute');
                
            setEndDateTime(newEndDateTime);
            updatedValue = newEndDateTime.format('YYYY-MM-DD HH:mm:ss');
        }

        return {
            ...prev,
            [field]: updatedValue
        };
    });
};

    useEffect(() => {
    if (openModal && modalEditDetails?.start && modalEditDetails?.end) {
        setModalStartTime(dayjs(modalEditDetails.start));
        setModalEndTime(dayjs(modalEditDetails.end));
    }
    }, [openModal, modalEditDetails]);

    const handleSaveNewShift = async () => {
        const driverIdToSend = newShift.driver_id || newShiftDriverId;
        // validation: ensure times provided
        setFormSubmitted(true);
        if (!newShift.vehicle_id) {
            return; // Don't submit if no vehicle is selected
        }
        if (!newShift.start_time || !newShift.end_time) {
            setMessage('Please provide both start and end time for the shift');
            showSnackbar(true);
            return;
        }

        // ensure start < end
// Build start datetime using CURRENT start date
        const newStart = dayjs(
        `${dateTime.format('YYYY-MM-DD')} ${dayjs(newShift.start_time).format('HH:mm:ss')}`,
        'YYYY-MM-DD HH:mm:ss'
        );

        if (!newendDateTime || !newendDateTime.isValid()) {
            newendDateTime = dateTime;
        }

        // Build end datetime using CURRENT end date
        let newEnd = dayjs(
        `${newendDateTime.format('YYYY-MM-DD')} ${dayjs(newShift.end_time).format('HH:mm:ss')}`,
        'YYYY-MM-DD HH:mm:ss'
        );

        if (!newStart.isValid() || !newEnd.isValid()) {
            setMessage('Invalid shift timing.');
            showSnackbar(true);
            return;
        }
        if (!newEnd.isAfter(newStart)) {
            setMessage('End time must be after start time');
            showSnackbar(true);
            return;
        }


        // find existing shifts for the driver (from editDetails or drivers list)
        const driverIdToCheck = newShift.driver_id || newShiftDriverId;
        let existingShifts = [];
        if (editDetails && String(editDetails.driver_id) === String(driverIdToCheck)) {
            existingShifts = editDetails.shift_timing || [];
        } else {
            const drv = drivers.find(d => String(d.driver_id) === String(driverIdToCheck));
            existingShifts = drv ? (drv.shift_timing || []) : [];
        }

        // helper to normalize existing shift datetime to dayjs (use dateTime's date if only time present)
        const normalizeExisting = (shift) => {
            if (!shift) return null;
            const startVal = shift.start;
            const endVal = shift.end;
            const dateStr = dateTime.format('YYYY-MM-DD');

            const parseVal = (val) => {
                if (!val) return null;
                const s = String(val);
                if (s.includes('T') || s.includes('-')) {
                    return dayjs(s);
                }
                // assume it's time-only like HH:mm:ss or HH:mm
                const timeOnlyParts = s.split(':').map(p => (p || '0').padStart(2, '0'));
                if (timeOnlyParts.length === 2) timeOnlyParts.push('00');
                return dayjs(`${dateStr} ${timeOnlyParts.slice(0,3).join(':')}`, 'YYYY-MM-DD HH:mm:ss');
            };

            return {
                start: parseVal(startVal),
                end: parseVal(endVal)
            };
        };

        // check overlap: newStart < existingEnd && existingStart < newEnd
        // for (const ex of existingShifts) {
        //     // skip if it's the same temporary unsaved shift (no shift_id) or removing check for same id if needed
        //     // normalize
        //     const norm = normalizeExisting(ex);
        //     if (!norm || !norm.start || !norm.end) continue;
        //     if (newStart.isBefore(norm.end) && norm.start.isBefore(newEnd)) {
        //         setMessage('New shift overlaps with existing shift. Please choose a different time.');
        //         showSnackbar(true);
        //         return;
        //     }
        // }

        // Add the new shift to the editableShifts only after successful save
        try {
            const token = localStorage.getItem('token');
            const url = operationsUrl + "/driver/add_update_shifts_timings";
            const payload = {
                shift_id: newShift.shift_id,
                start_time:  newStart.format('YYYY-MM-DD HH:mm:ss'),
                // start_time: dateTime.format('YYYY-MM-DD') + " " + newShift.start_time,
                // end_time: dateTime.format('YYYY-MM-DD') + " " + newShift.end_time,
                end_time:  newEnd.format('YYYY-MM-DD HH:mm:ss'),
                vehicle_id: newShift.vehicle_id,
                driver_id: driverIdToSend,
                city_id: cityFilter,
                token: token
            };
            const response = await makePostRequestToUrl(url, payload);

            if(response.flag == 710 || response.flag == 711 || response.flag == 709){
                setErrorDialog(true);
                seterrordialogeMessage(response?.message || 'Failed to update shift status');
            }

            if (response && response.flag === 200) {
                // Re-fetch the shifts and update modal state so modal shows updated data
                const updatedData = await fetchShiftTimingData();
                const driverId = payload.driver_id;
                const updatedDriver = updatedData?.find(d => d.driver_id?.toString() === driverId?.toString());

                if (updatedDriver) {
                    setEditDetails(updatedDriver);
                    setEditableShifts([...updatedDriver.shift_timing]);
                } else {
                    // fallback: append the local newShift to editableShifts so UI updates immediately
                    setEditableShifts(prev => [...prev, { ...newShift }]);
                }

                // reset newShift and hide add form but keep the modal open
                setNewShift({
                    start_time: '',
                    end_time: '',
                    vehicle_id: '',
                    driver_id: ''
                });
                setNewShiftCounter(1);
                setShowAddShiftForm(false);
                setFormSubmitted(false);
                const today = dayjs().startOf('day');
                setDateTime(today);


                setMessage('Shift saved successfully');
                showSnackbar(true);
            } else {
                setMessage(response?.message || 'Failed to save shift');
                showSnackbar(true);
            }
        } catch (error) {
            console.error(error);
            setMessage('Failed to save shift');
            showSnackbar(true);
        }
    };
    const handleCancelAddShift = () => {
        setShowAddShiftForm(false);
        setNewShift({
            start_time: '',
            end_time: '',
            vehicle_number: '',
            driver_id: ''
        });
        setNewShiftCounter(prev => prev - 1);
    };

    // helper: check if a specific shift was modified
    const shiftHasChanged = (index) => {
        const orig = editDetails?.shift_timing?.[index] || {};
        const curr = editableShifts?.[index] || {};
        const norm = v => (v === null || v === undefined) ? '' : String(v).trim();

        return (
            norm(orig.start) !== norm(curr.start) ||
            norm(orig.end) !== norm(curr.end) ||
            norm(orig.vehicle_number) !== norm(curr.vehicle_number) ||
            norm(orig.vehicle_id) !== norm(curr.vehicle_id) ||
            norm(orig.driver_id) !== norm(curr.driver_id)
        );
    };

    const handleCancelShiftEdit = (index) => {
        // revert single shift to original values
        const original = editDetails?.shift_timing?.[index];
        if (!original) return;
        const updated = [...editableShifts];
        updated[index] = { ...original };
        setEditableShifts(updated);
    };

    const handleActiveDeactiveShift = async () => {
        try {
            const token = localStorage.getItem('token');
            const url = operationsUrl + "/driver/update_driver_shifts_status";
            const payload = {
                date: mainselectedDate.format('YYYY-MM-DD'),
                is_active: status ? 0 : 1,
                city_id: cityFilter,
                token
            };
            const response = await makePostRequestToUrl(url, payload);
            if(response && response.flag === 711){
                setErrorDialog(true);
                seterrordialogeMessage(response?.message || 'Failed to update shift status');
                setStatus(status)
            }
            if (response && response.flag === 200) {
                // Re-fetch the shifts and update modal state so modal shows updated data
                setStatus(!status);
                const updatedData = await fetchShiftTimingData();
                const driverId = payload.driver_id;
                const updatedDriver = updatedData?.find(d => d.driver_id?.toString() === driverId?.toString());
                if (updatedDriver) {
                    setEditDetails(updatedDriver);
                    setEditableShifts([...updatedDriver.shift_timing]);
                }
                setMessage('Shift status updated successfully');
                showSnackbar(true);
            } else {
                setMessage(response?.message || 'Failed to update shift status');
                showSnackbar(true);
            }
        } catch (error) {
            console.error(error);
            setMessage('Failed to update shift status');
            showSnackbar(true);
        }
    }

    const handleSaveShift = async (index) => {
        try {
            const shiftToSave = editableShifts[index];
            if (!shiftToSave) return;
            const token = localStorage.getItem('token');
            const vehicleIdFromShift = shiftToSave.vehicle_id ?? null;
            const vehicleIdFromDriverInfo = shiftToSave.driver_info?.vehicle_id ?? shiftToSave.driver_info?.client_vehicle_id ?? shiftToSave.driver_info?.vehicle?.id ?? null;
            const vehicleId = vehicleIdFromShift ?? vehicleIdFromDriverInfo ?? null;
            const startTimeOnly = timeOnly(shiftToSave.start);
            const endTimeOnly = timeOnly(shiftToSave.end);
            // helper to parse existing shift times to dayjs using the same date
            const parseExistingToDayjs = (val) => {
                if (!val) return null;
                const s = String(val);
                if (s.includes('T') || s.includes('-')) return dayjs(s);
                const parts = s.split(':').map(p => (p || '0').padStart(2, '0'));
                if (parts.length === 2) parts.push('00');
                return dayjs(`${dateTime.format('YYYY-MM-DD')} ${parts.slice(0,3).join(':')}`, 'YYYY-MM-DD HH:mm:ss');
            };

            const normalizeShift = (start, end) => {
                let s = parseExistingToDayjs(start);
                let e = parseExistingToDayjs(end);

                if (!s || !e) return null;

                if (e.isBefore(s)) {
                    e = e.add(1, 'day');
                }

                return { start: s, end: e };
            };


            // --- Overlap validation for edited shift ---
            // construct dayjs for the new start/end using selected date
            const newStart = dayjs(
                `${dateTime.format('YYYY-MM-DD')} ${startTimeOnly}`,
                'YYYY-MM-DD HH:mm:ss'
            );

            let newEnd = dayjs(
                `${endDateTime.format('YYYY-MM-DD')} ${endTimeOnly}`,
                'YYYY-MM-DD HH:mm:ss'
            );

            if (!newStart.isValid() || !newEnd.isValid()) {
                setMessage('Invalid shift timing.');
                showSnackbar(true);
                return;
            }

            // Overnight support
            if (!newEnd.isAfter(newStart)) {
                setMessage('End time must be after start time');
                showSnackbar(true);
                return;
            }



            // get shifts for this driver (from editDetails if same driver, otherwise from drivers list)
            const driverIdToCheck = shiftToSave.driver_id ?? editDetails?.driver_id;
            let existingShifts = [];
            if (editDetails && String(editDetails.driver_id) === String(driverIdToCheck)) {
                existingShifts = editDetails.shift_timing || [];
            } else {
                const drv = drivers.find(d => String(d.driver_id) === String(driverIdToCheck));
                existingShifts = drv ? (drv.shift_timing || []) : [];
            }

            for (const ex of existingShifts) {
            if (
                ex.shift_id &&
                shiftToSave.shift_id &&
                String(ex.shift_id) === String(shiftToSave.shift_id)
            ) continue;

            const normalized = normalizeShift(ex.start, ex.end);
            if (!normalized) continue;

            if (newStart.isBefore(normalized.end) &&
                normalized.start.isBefore(newEnd)) {
                setMessage('Shift overlaps with an existing shift.');
                showSnackbar(true);
                return;
            }
            }


            const payload = {
                shift_id: shiftToSave.shift_id || undefined,
                // start_time: dayjs(dateTime).utc().format('YYYY-MM-DD') + " " + startTimeOnly,
                // end_time: dayjs(dateTime).utc().format('YYYY-MM-DD') + " " + endTimeOnly,
                start_time: newStart.format('YYYY-MM-DD HH:mm:ss') ,
                end_time: newEnd.format('YYYY-MM-DD HH:mm:ss'),
                // start_time: `${dateTime.format('YYYY-MM-DD')} ${startTimeOnly}`,
                // end_time: `${dateTime.format('YYYY-MM-DD')} ${endTimeOnly}`,
                vehicle_id: vehicleId ?? undefined,
                driver_id: shiftToSave.driver_id ?? editDetails?.driver_id,
                token,
            };

            const url = operationsUrl + "/driver/add_update_shifts_timings";
            const response = await makePostRequestToUrl(url, payload);

            if(response.flag == 710 || response.flag == 711 || response.flag == 709){
                setErrorDialog(true);
                seterrordialogeMessage(response?.message || 'Failed to update shift status');
            }

            if (response && response.flag === 200) {
                setMessage('Shift saved successfully');
                showSnackbar(true);
                setEditingShiftId(null);

                const updatedShiftFromApi = response.data?.shift || response.data?.updated_shift;
                if (updatedShiftFromApi) {
                    const updated = [...editableShifts];
                    updated[index] = {
                        ...updated[index],
                        start: updatedShiftFromApi.start_time ?? updated[index].start, 
                        end: updatedShiftFromApi.end_time ?? updated[index].end,       
                        vehicle_number: updatedShiftFromApi.vehicle_number ?? updated[index].vehicle_number,
                        vehicle_id: updatedShiftFromApi.vehicle_id ?? updated[index].vehicle_id,
                        shift_id: updatedShiftFromApi.shift_id ?? updated[index].shift_id,
                        is_active: updatedShiftFromApi.is_active ?? updated[index].is_active,
                    };
                    setEditableShifts(updated);

                    const ed = { ...editDetails };
                    ed.shift_timing = [...updated];
                    setEditDetails(ed);
                } else {
                    const all = await fetchShiftTimingData();
                    const updatedDriver = all?.find(d => d.driver_id?.toString() === editDetails?.driver_id?.toString());
                    if (updatedDriver) {
                        setEditDetails(updatedDriver);
                        setEditableShifts([...updatedDriver.shift_timing]);
                    }
                }
            } else {
                setMessage(response?.message || 'Failed to save shift');
                showSnackbar(true);
            }
        } catch (err) {
            console.error('Failed to save shift:', err);
            setMessage('Failed to save shift');
            showSnackbar(true);
        }
    };
    const handleFilterChange = (filterType, value) => {    //handle the city filter
        if (filterType === 'city') setCityFilter(value);
    };
    // format selected date as YYYY-MM-DD
    const selectedDateKey = dateFilter.format("YYYY-MM-DD");
    // Filter drivers for table based on selected driver id
    const displayedDrivers = useMemo(() => {
        if (!driver) return drivers;
        return drivers.filter(d => String(d.driver_id) === String(driver));
    }, [drivers, driver]);
    // Compute max shifts from filtered list to keep header aligned
    const maxShifts = displayedDrivers.length > 0
        ? Math.max(...displayedDrivers.map(d => d.shift_timing.length))
        : 0;

    const Modalstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: "20px",
        p: 4,
    };


    const fetchShiftRideDetails = async (shift_id) => {

        try {
            const token = localStorage.getItem('token');
            const url = `${serverUrl}/driver/fetch_shifts_ride_details`;
            const obj = {
                token,
                driver_shift_id: shift_id,
            };
            const response = await makeGetRequestToUrl(url, obj);
            setDayShift(response?.data);

            if (response.flag === 102) {
                console.log('Token is expired. Please login again');
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                return;
            }
            if (response.flag === 200) {
                setShiftRideDetails(response.data);
            }
        } catch (error) {
            console.error("Error fetching shift timing data:", error);
            // setMessage('Failed to fetch shift data');
            // showSnackbar(true);
        } finally {
            isFetching.current = false;
        }
    }

    const formatTime = (dateTimeString) => {
        if (!dateTimeString) return '--';
        const s = String(dateTimeString);
        let parsed;
        if (/^\d{2}:\d{2}(:\d{2})?$/.test(s)) {
            const base = (mainselectedDate ? dayjs(mainselectedDate) : dayjs()).format('YYYY-MM-DD');
            const time = s.length === 5 ? `${s}:00` : s;
            parsed = dayjs(`${base} ${time}`, 'YYYY-MM-DD HH:mm:ss');
        } else {
            parsed = dayjs(s.includes('T') ? s : s.replace(' ', 'T'));
        }
        if (!parsed.isValid()) return '--';
        const adjusted = parsed.add(utcOffset, 'minute').utc();
        const dateFormat = date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD";
        const timeFormat = timeZoneFormat === '12' ? 'hh:mm A' : 'HH:mm';
    
    return adjusted.format(`${dateFormat} ${timeFormat}`);
        // return timeZoneFormat === '12'
        //     ? adjusted.format('hh:mm A')
        //     : adjusted.format('HH:mm');
    };

    const isShiftExpired = (shift) => {
        if (!shift?.end) return false;
        
        const utcOffsetVal = parseInt(localStorage.getItem('utc_offset') || '240', 10);
        const shiftEndTime = dayjs.utc(shift.end).add(utcOffsetVal, 'minute');
        const currentTime = dayjs().add(utcOffsetVal, 'minute');
        
        return shiftEndTime.isBefore(currentTime);
    };

    //  const timeStringToDayjs = (timeStr) => {    
    //     console.log(timeStr,"timestar")
    //     if (!timeStr) return null;
    //     const parts = String(timeStr).split(':').map(p => parseInt(p, 10) || 0);
    //    const [h = 0, m = 0, s = 0] = parts;
    //    const time = dayjs().hour(h).minute(m).second(s)
    //     return time;
    // };
const timeStringToDayjs = (timeStr) => {
  if (!timeStr) return null;

  const utcOffsetVal = parseInt(localStorage.getItem('utc_offset') || '240', 10); // in minutes

  // Parse ISO as UTC, then add only your app offset
  return dayjs.utc(timeStr).add(utcOffsetVal, 'minute');
};



    const timeOnly = (val) => {
        if (!val) return '';
        const s = String(val);
        const utcOffsetVal = parseInt(localStorage.getItem('utc_offset') || '330', 10); // e.g., 330 for IST

        // If it's an ISO string (UTC)
        if (s.includes('T')) {
            return dayjs.utc(s).utcOffset(utcOffsetVal).format('HH:mm:ss');
        }

        const parts = s.split(':').map(p => (p || '0').padStart(2, '0'));
        if (parts.length === 2) return `${parts[0]}:${parts[1]}:00`;
        if (parts.length >= 3) return `${parts[0]}:${parts[1]}:${parts[2]}`;
        
        // Fallback parse
        return dayjs(s).utcOffset(utcOffsetVal).format('HH:mm:ss');
    };

    const handlestatus = () => {
        handleActiveDeactiveShift();
    }



    const handleMenuClick = (event, shift) => {
        setAnchorEl2(event.currentTarget);
        setSelectedShift(shift);
    };


    const handlemaineditclick = (event, driver) => {
        setmaineditclick(event.currentTarget);
        setSelectedDriver(driver); // ✅ store the clicked driver
    };


    const handleMenuClose = () => {
        setAnchorEl2(null);
        setSelectedShift(null);
    };

    // const handleOpenAddModal = (driver) => {
    //     console.log(driver,"driver")
    //     setNewShiftCounter(0);
    //     setNewShiftDriverId(driver?.driver_id)
    //     setOpenAddModal(true);
    //     setDateTime(driver);
    //     setEndDateTime(mainselectedDate);
    //     setEditDetails(driver);
    // }
const extractShiftDateTimeFromApi = (shift) => {
    if (!shift?.start_time || !shift?.end_time) return null;

    // ✅ Convert UTC → local ONCE
    const localStart = dayjs(shift.start_time).local();
    const localEnd   = dayjs(shift.end_time).local();

    return {
        startDate: localStart,   // 👈 full datetime (NOT startOf day)
        endDate: localEnd,
        startTime: localStart.format('HH:mm'),
        endTime: localEnd.format('HH:mm'),
        vehicle_id: shift.vehicle_id,
        vehicle_number: shift.vehicle_number,
        isOvernight: !localEnd.isSame(localStart, 'day')
    };
};




const handleOpenAddModal = (driver) => {
    setOpenAddModal(true);
    setNewShiftCounter(0);
    setNewShiftDriverId(driver?.driver_id);
    setEditDetails(driver);

    const shifts = driver?.shift_timing || driver?.shifts || [];

    if (shifts.length > 0) {
        const lastShift = shifts.at(-1);

        const extracted = extractShiftDateTimeFromApi({
            start_time: lastShift.start_time || lastShift.start,
            end_time: lastShift.end_time || lastShift.end,
            vehicle_id: lastShift.vehicle_id,
            vehicle_number: lastShift.vehicle_number
        });

        if (extracted) {
            setDateTime(extracted.startDate);
            setEndDateTime(extracted.endDate);

            setNewShift({
                start_time: extracted.startTime,
                end_time: extracted.endTime,
                vehicle_id: extracted.vehicle_id || '',
                driver_id: driver.driver_id
            });
        }
    } else {
        const baseDate = dayjs(mainselectedDate || dayjs()).local();

        setDateTime(baseDate);
        setEndDateTime(baseDate);

        setNewShift({
            start_time: '',
            end_time: '',
            vehicle_id: '',
            driver_id: driver?.driver_id
        });
    }
};





    const handleClose = () => {
        setFormSubmitted(false);
        setShowAddShiftForm(false);
        setOpenAddModal(false);
        setopenViewModal(false);
        setEditDetails(null);
        setNewShift({
            start_time: '',
            end_time: '',
            vehicle_number: '',
            driver_id: ''
        });
        setVehicleId('');
        setNewShiftCounter(0);
    }

    const handleSubmit = async (shift) => {


        const payload = {
            shift_id: shift.shift_id || undefined,
            vehicle_id: modalVehicle?.id || undefined,
            driver_id: modalDriver?.driver_id || undefined,
            token,
        }
        if(modalStartTime && modalEndTime){
            // payload.start_time = mainselectedDate.format('YYYY-MM-DD') + " " + modalStartTime;
            // payload.end_time = mainselectedDate.format('YYYY-MM-DD') + " " + modalEndTime;
            payload.start_time= modalStartTime.format('YYYY-MM-DD HH:mm:ss');
            payload.end_time= modalEndTime.format('YYYY-MM-DD HH:mm:ss');

        }
        if (!payload.start_time || !payload.end_time) {
        setMessage('Please provide both start and end time for the shift');
        showSnackbar(true);
        return;
    }

        // ⏳ Parse the times using dayjs (or Date)
        const newStart = dayjs(payload.start_time, 'YYYY-MM-DD HH:mm:ss');
        let  newEnd = dayjs(payload.end_time, 'YYYY-MM-DD HH:mm:ss');
        // const newStart = dayjs(payload.start_time).utc().format('YYYY-MM-DD');
        // const newEnd = dayjs(payload.end_time).utc().format('YYYY-MM-DD');

            if (!newStart.isValid() || !newEnd.isValid()) {
                setMessage('Invalid shift timing.');
                showSnackbar(true);
                return;
            }

            // Overnight support
            if (!newEnd.isAfter(newStart)) {
                setMessage('End time must be after start time');
                showSnackbar(true);
                return;
            }

        const url = operationsUrl + "/driver/add_update_shifts_timings";
        const response = await makePostRequestToUrl(url, payload);
        if(response.flag == 710 || response.flag == 711 || response.flag == 709){
                setErrorDialog(true);
                seterrordialogeMessage(response?.message || 'Failed to update shift status');
            }
        if (response.flag == 200) {
            setOpenModal(false);
            setModalDriver(null);
            setModalVehicle(null);
            showSnackbar(true);
            setMessage('Shift saved successfully');
            fetchShiftTimingData();
            setModalDriver(null);
            setModalVehicle(null);
        }
        setMessage(response.message);
        showSnackbar(true);
    }

    const handlemodalClose = () => {
        setOpenModal(false);
        setModalDriver(null);
        setModalVehicle(null);
    }
    const handleopenViewModal = (Driver) => {
        setopenViewModal(true);
        setEditDetails(Driver);
    }
    const handleDeleteConfirmModalOpen = (shift_id) => {
        setOpenDeleteConfirmModal(true);
        setDeletingShiftId(shift_id);
    }
    const handleDeleteConfirmModalClose = () => {
        setOpenDeleteConfirmModal(false);
        setDeletingShiftId(null);
    }

    const handleViewModalOpen = async (Shift_id) => {
        fetchShiftRideDetails(Shift_id);
        setSingleShiftModal(true);
        setSingleShiftId(Shift_id);
    }
    const handleViewModalClose = () => {
        setSingleShiftModal(false);
        handleMenuClose();
        setSingleShiftId(null);
    }

    const handleOverWriteModalapprove = async () => {
        try {
            // Set override status to true and make the API call again
            // setMainselectedDate();
            setOverridestatus(true);
            
            // Close the modal
            setOpenOverWriteModal(false);
            
            // Make the API call with override=true
            const url = `${operationsUrl}/driver/add_bulk_shifts`;
            const token = localStorage.getItem('token');
            const payload = {
                city_id: cityFilter,
                token,
                driver_shifts: dummydata.driver_shifts,
                is_active: status ? 1 : 0,
                override_shifts: 1, // Set override to 1 for the second attempt
            };
            
            const response = await makePostRequestToUrl(url, payload);
            
            // Show success message
            setMessage(response.message);
            showSnackbar(true);
            
            // Update the UI
            skipFetchRef.current = true;
            setMainselectedDate(pasteDate);
            setDateFilter(pasteDate);

            
            // Refresh the data
            // fetchShiftTimingData();
            
        } catch (error) {
            console.error('Error in bulk update with override:', error);
            setMessage(error.message || 'Failed to update shifts with override');
            showSnackbar(true);
        }
    };

    useEffect(() => {
        if (editingShiftIndex !== null && modalDriverDetails?.shift_timing?.[editingShiftIndex]) {
            const s = modalDriverDetails.shift_timing[editingShiftIndex].start;
            const e = modalDriverDetails.shift_timing[editingShiftIndex].end;
            setModalStartTime(s ? dayjs(s) : null);
            setModalEndTime(e ? dayjs(e) : null);
        } else {
            setModalStartTime(null);
            setModalEndTime(null);
        }
    }, [editingShiftIndex, modalDriverDetails]);

    const handleOverWriteModalreject = () => {
        setOpenOverWriteModal(false);
        setMainselectedDate(pasteDate);
        setDeletingShiftId(null);
    }

    const [age, setAge] = React.useState('');

    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const isFetching = useRef(false);
    const fetchShiftTimingData = async () => {
        if (isFetching.current) return;
        isFetching.current = true;
        try {
            const token = localStorage.getItem('token');
            const url = `${serverUrl}/driver/shifts`;
            const obj = {
                token,
                date:mainselectedDate.format('YYYY-MM-DD'),
                ...(cityFilter && { city_id: cityFilter }),
            };
            const response = await makeGetRequestToUrl(url, obj);
            setDayShift(response?.data);

            if (response.flag === 102) {
                console.log('Token is expired. Please login again');
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                return;
            }
            if (response.flag === 200) {
                if (response.data && response.data.driver_shifts && response.data.driver_shifts.length > 0) {
                    const formattedData = response.data.driver_shifts.map(driver => ({
                        driver_id: driver.driver_id,
                        driver_name: driver.driver_name,
                        driver_phone_number: driver.driver_phone_number,
                        shift_timing: driver.shifts.map(shift => ({
                            shift_id: shift.shift_id ?? shift.id ?? null,
                            start: shift.start_time,
                            end: shift.end_time,
                            is_active: shift.is_active,
                            vehicle_number: shift.vehicle_number ?? shift.vehicle_no ?? '',
                            vehicle_id: shift.vehicle_id ?? shift.client_vehicle_id ?? null,
                            driver_id: shift.driver_id ?? driver.driver_id ?? null,
                            __raw: shift
                        }))
                    }));
                    setEmptystatus(false);
                    setDrivers(formattedData);
                    setStatus(response.data.is_shift_active);
                    setNewShiftCounter(1);
                    return formattedData || [];
                } else {
                    setDrivers([]);
                    setStatus(false);
                    setEmptystatus(true);
                }
            }
        } catch (error) {
            console.error("Error fetching shift timing data:", error);
            // setMessage('Failed to fetch shift data');
            // showSnackbar(true);
        } finally {
            isFetching.current = false;
        }
    };
    const fetchAvailableVehicles = async () => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/vehicle/fetch_vehicle_make';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if (response.flag == 200) {
                // Filter active vehicles
                const activeVehicles = response.data;
                setAvailableVehicle(activeVehicles);
            }
            if (response.flag == 102) {
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        if (skipFetchRef.current) {
            skipFetchRef.current = false;
            return;
       }
        fetchShiftTimingData();
    }, [cityFilter, date, mainselectedDate,isPasting]);

    useEffect(() => {
        fetchShiftTimingData();
    }, [mainselectedDate]);
    useEffect(() => {
        fetchAvailableVehicles();
    }, [cityFilter]);

    const fetchCityDrivers = async (client_vehicle_id, ride_id) => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            // const url = `${serverUrl}/driver/fetch_city_driver`;
            const url = serverUrl + "/driver/fetch_all"
            const obj = {
                token: token,
                timestamp: timestamp,
                city_id: cityFilter,
                scheduled_id: ride_id,
                client_vehicle_id: client_vehicle_id
            }
            const response = await makeGetRequestToUrl(url, obj);

            if (response.flag == 411) {
                setNoDriverMessage(response.message);
            }

            if (response.flag == 102) {
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if (response.flag === 200) {
                const cityDriversData = response.data;
                setDriversData(cityDriversData);
                setNoDriverMessage('');
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchCityDrivers();
    }, [cityFilter]);
    const renderField = (shiftId, field, start_timing, end_timing, vehicleno) => {
    const formatDateTime = (dateTime) => {
        if (!dateTime) return { date: '', time: '' };
        const dt = dayjs(dateTime);
        return {
            date: dt.format('DD-MM-YYYY'),
            time: dt.format('hh:mm A')
        };
    };
    const start = formatDateTime(start_timing);
    const end = formatDateTime(end_timing);
    const isDifferentDay = !dayjs(end.date, 'DD-MM-YYYY').isSame(mainselectedDate, 'day');
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: '100%',
                    "&:hover .edit-icon": { visibility: "visible" }
                }}
            >
                {field === "timing" ? (
                    <>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'left',
                        gap: 1,
                        justifyContent: 'flex-start',
                        width: '100%'
                    }}>
                        <span style={{ textAlign: 'left' }}>{start.date}</span> :- <span style={{ textAlign: 'left',color: '#666' }}>{" "}{start.time}</span>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        alignItems: 'left',
                        gap: 1,
                        justifyContent: 'flex-start',
                        width: '100%'
                    }}>
                        {<span style={{ 
                                textAlign: 'left',
                                color: isDifferentDay ? '#0065ff' : 'inherit'
                            }}>
                                {end.date}
                            </span>}:- <span style={{ textAlign: 'left', color: '#666' }}>{" "}{end.time}</span>
                    </Box>
                    </>
                ) : (
                    <Box sx={{
                        color: '#666',
                        fontSize: '0.9rem',
                        textAlign: 'left',
                        width: '100%'
                    }}>
                        {vehicleno}
                    </Box>
                )}
            </Box>
        );
    };


    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        showSnackbar(false);
    };

    const handlemaindateSelect = (newValue) => {
        if(isPasting) return;
        setMainselectedDate(newValue);
        setNewEndDateTime(newValue);
    };

    const handleDeleteshift = async (shiftId) => {
        try {
            const token = localStorage.getItem('token');
            const url = operationsUrl + "/driver/add_update_shifts_timings";
            const payload = {
                shift_id: shiftId,
                is_active: -1,
                token,
            };
            const response = await makePostRequestToUrl(url, payload);

            if(response.flag == 710 || response.flag == 711 || response.flag == 709){
                setErrorDialog(true);
                seterrordialogeMessage(response?.message || 'Failed to update shift status');
            }

            if (response && response.flag === 200) {
                // Re-fetch the shifts and update modal state so modal shows updated data
                const updatedData = await fetchShiftTimingData();
                const driverId = payload.driver_id;
                const updatedDriver = updatedData?.find(d => d.driver_id?.toString() === driverId?.toString());

                if (updatedDriver) {
                    setEditDetails(updatedDriver);
                    setEditableShifts([...updatedDriver.shift_timing]);
                } else {
                    // fallback: append the local newShift to editableShifts so UI updates immediately
                    setEditableShifts(prev => [...prev, { ...newShift }]);
                }

                // reset newShift and hide add form but keep the modal open
                setNewShift({
                    start_time: '',
                    end_time: '',
                    vehicle_id: '',
                    driver_id: ''
                });
                setNewShiftCounter(1);
                setShowAddShiftForm(false);
                handleDeleteConfirmModalClose();

                setMessage('Shift Deleted successfully');
                showSnackbar(true);
            } else {
                setMessage(response?.message || 'Failed to delete shift');
                showSnackbar(true);
            }
        } catch (error) {
            console.error(error);
            setMessage('Failed to save shift');
            showSnackbar(true);
        }
    };



    useEffect(() => {
        const currentDateKey = dateFilter.format("YYYY-MM-DD");
        const previousDateKey = previousDate.format("YYYY-MM-DD");

        if (currentDateKey !== previousDateKey && copiedData) {
            setPendingPasteDate(currentDateKey);
            setShowPasteDialog(true);
        }
        setPreviousDate(dateFilter);
    }, [dateFilter]);

    const handleCopyClick = (event, shifts, date) => {
        if (!shifts || (Array.isArray(shifts) && shifts.length === 0)) {
            setMessage('No shifts to copy');
            showSnackbar(true);
            return;
        }
        setOverridestatus(false);
        setAnchorEl(null);
        setAnchorEl(event.currentTarget);
        // setMainselectedDate(date);
        // Ensure we're always storing an array
        setCopiedShifts(Array.isArray(shifts) ? [...shifts] : [shifts]);
        setCopyDate(date);
    };
      
      const handleCloseMenu = () => {
        setAnchorEl(null);
      };
      
      const handlePasteDateSelect = (newDate) => {
        if (newDate) {
            setPasteDate(newDate);
            setAnchorEl(null);
            setShowPasteDialog(true);
        }
    };

    const handlePasteConfirm = async () => {
        if (!copiedShifts || !pasteDate) {
            console.error('No shifts to paste or no date selected');
            return;
        }
    
        try {
            const shiftsToPaste = Array.isArray(copiedShifts) ? [...copiedShifts] : [copiedShifts];
            
            // Create a map to group shifts by driver_id
            const driverShiftsMap = new Map();
            
            // Process each shift and group by driver_id
            shiftsToPaste.forEach(shiftGroup => {
                const driverShifts = shiftGroup.driver_shifts || [];
                
                driverShifts.forEach(driverShift => {
                    const driverId = driverShift.driver_id;
                    const shifts = driverShift.shifts || [];
                    
                    if (!driverShiftsMap.has(driverId)) {
                        driverShiftsMap.set(driverId, {
                            driver_id: driverId,
                            shifts: []
                        });
                    }
                    
                    // Add all shifts for this driver
                    shifts.forEach(shift => {
                        const startTime = dayjs(shift.start_time);
                        const endTime = dayjs(shift.end_time);
                        
                        const startDateTime = dayjs(pasteDate).hour(startTime.hour()).minute(startTime.minute()).second(startTime.second());
                        let endDateTime = dayjs(pasteDate).hour(endTime.hour()).minute(endTime.minute()).second(endTime.second());
                        const startHour = startTime.hour();
                        const endHour = endTime.hour();
                        
                        if (endHour < startHour || (endHour === startHour && endTime.minute() < startTime.minute())) {
                            endDateTime = endDateTime.add(1, 'day');
                        }
                        
                        driverShiftsMap.get(driverId).shifts.push({
                            start_time: startDateTime.format('YYYY-MM-DD HH:mm:ss'),
                            end_time: endDateTime.format('YYYY-MM-DD HH:mm:ss'),
                            vehicle_id: shift.vehicle_id
                        });
                    });
                });
            });
    
            // Convert the map values to an array
            const driverShifts = Array.from(driverShiftsMap.values());
    
            // Update the local state with the new structure
            setDummydata({
                driver_shifts: driverShifts
            });
            const token = localStorage.getItem('token');
            const url = operationsUrl + '/driver/add_bulk_shifts';
            const payload = {
                city_id:cityFilter,
                token,
                driver_shifts:driverShifts,
                is_active:status ? 1 : 0,
                override_shifts:overridestatus ? 1 : 0,
            }
            const response = await makePostRequestToUrl(url,payload);
            if(response.flag==709){
                setOpenOverWriteModal(true);
                return;
            }
                setMessage(response.message);
                showSnackbar(true);
                
                // prevent the automatic fetch caused by changing these dates
                skipFetchRef.current = true;
                setMainselectedDate(pasteDate);
                setDateFilter(pasteDate);
    
                // Refresh the data
                // fetchShiftTimingData();
    
            
        } catch (error) {
            console.error('Error pasting shifts:', error);
            setMessage(error.message);
            showSnackbar(true);
        } finally {
            setShowPasteDialog(false);
        }
    };

    const handlePasteCancel = () => {
        setShowPasteDialog(false);
        setCopiedData(null);
        setIsPasting(false)
    };

    const handleerrordialogeClose = () => {
        setErrorDialog(false);
    };

    return (
        <div>
            {tokenExpired && (<TokenError />)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Shift Timing</Typography>
            <Grid2 container spacing={1.5} xs={12} md={8} alignItems="flex-end" sx={{ marginTop: '1%' }}>
                <Grid2 sx={{ marginRight: '1%' }}>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleFilterChange('city', e.target.value)}
                        displayEmpty
                        style={{
                            width: '200px',
                            height: '46px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">All</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Box
                        sx={{
                            position: 'relative',
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: '#F9F9F9',
                            borderRadius: '8px',
                            height: '46px',
                            width: '200px',
                            padding: '0 12px',
                            border: '1px solid #e0e0e0'
                        }}
                    >
                        <img
                            src={MagnifierIcon}
                            alt="Search"
                            style={{
                                width: '20px',
                                height: '20px',
                                marginRight: '8px'
                            }}
                        />
                        <input
                            type="text"
                            placeholder="Search here"
                            className='filterBtn'
                            style={{
                                width: '70%',
                                height: '100%',
                                border: 'none',
                                outline: 'none',
                                backgroundColor: 'transparent',
                                fontSize: '14px',
                                paddingLeft: '4px'
                            }}
                        />
                    </Box>
                </Grid2>
                <Grid2 item xs={12} sm={6}>
                    <TextField
                        label={<span>Select Driver </span>}
                        select
                        fullWidth
                        variant="outlined"
                        value={driver}
                        onChange={(e) => setDriver(e.target.value)}
                        InputProps={{
                            style: {height: '48px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                        }}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                            '& .MuiInputLabel-root': {fontSize: '16px'},
                            '& .MuiSelect-select': {
                                padding: '14px 14px',
                                minWidth: '150px'
                            }
                        }}
                    >
                        <MenuItem value="">All</MenuItem>
                        { drivers.map((driver) => (
                            <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                {driver.driver_name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid2>

                {/* <Grid2 item sx={{marginLeft:'1%'}}>
                    <Button
                        variant="contained"
                        style={{width:'180px',height: '42px',backgroundColor:'#0065FF',textTransform:'none',borderRadius:'8px'}}>
                        + Create Booking
                    </Button>
                </Grid2> */}
                <Grid2 item>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            sx={{
                                width: '200px',
                                '& .MuiInputBase-root': {
                                    height: '48px !important',
                                    width: '200px !important',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop: '4px',
                                    '& input': {
                                        padding: '12.5px 14px',  // Added padding to center the text vertically
                                    }
                                }
                            }}
                            value={mainselectedDate}
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            onChange={(newValue) => {
                                if (newValue) {
                                    // Use the local date directly without reformatting
                                    // setMainselectedDate(newValue);
                                    handlemaindateSelect(newValue);
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                    <Grid2 sx={{ marginRight: '10px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={(e) => {
                                handleOpenAddModal();
                                setShiftType("add");
                            }}
                            sx={{
                                height: '45px',
                                textTransform: 'none',
                                borderRadius: '8px',
                                minWidth: '120px',
                                backgroundColor: '#2563EB',
                                '&:hover': { backgroundColor: '#36C68F' }
                            }}
                        >
                            Add Shift
                        </Button>
                    </Grid2>
                    <Grid2 sx={{ marginRight: '10px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={(e) => {
                                handleCopyClick(e,dayshift,date);
                                // setAnchorEl(e.currentTarget);
                                // setShiftType("copy");
                            }}
                            sx={{
                                height: '45px',
                                textTransform: 'none',
                                borderRadius: '8px',
                                minWidth: '120px',
                                backgroundColor: '#2563EB',
                                '&:hover': { backgroundColor: '#36C68F' }
                            }}
                        >
                            Copy
                        </Button>

                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={() => setAnchorEl(null)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateCalendar 
                                    value={pasteDate}
                                    format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                                    onChange={(newValue) => {
                                        if (newValue) {
                                            handlePasteDateSelect(newValue);
                                        }
                                    }}
                                    renderInput={(params) => <TextField {...params} sx={{ display: 'none' }} />}
                                    open
                                    onClose={() => setAnchorEl(null)}
                                    disablePast
                                />
                            </LocalizationProvider>
                        </Popover>
                    </Grid2>
                    <Grid2 item sx={{ marginLeft: '1%', padding: '8px 20px', border: status ? '1px solid #0DBA78' : '1px solid #D14545', borderRadius: '28px', display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: status ? '#EFFBF7' : '#FFF5F5' }}>
                        <Typography sx={{ marginRight: '10px' }}>{status ? "Active" : "Inactive"}</Typography>
                        <AntSwitch checked={status} onClick={handlestatus} disabled={emptystatus} inputProps={{ 'aria-label': 'ant design' }} />
                    </Grid2>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container" sx={{ maxHeight: '67vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" sx={{minWidth: '270px' }}>
                                Driver Name
                            </TableCell>
                            {[...Array(maxShifts)].map((_, i) => (
                                <TableCell align="center" key={i} sx={{ color: '#83888E' }}>{`Shift ${i + 1} (Start- End)`}</TableCell>
                            ))}
                            <TableCell align="center" className="table-header">
                                Action
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayedDrivers.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={maxShifts + 2} align="center">
                                    <Typography variant="body1">No data available for {mainselectedDate.format('YYYY-MM-DD')}</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            displayedDrivers.map((driver, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Grid2 container sx={{ width: "auto", minWidth: "180px", alignItems: 'center', marginTop: '2%' }}>
                                                            <Grid2>
                                                              {driver.driver_image ? (
                                                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={driver.driver_image} />
                                                              ) : (
                                                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile} />
                                                              )}
                                                            </Grid2>
                                                            <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                              <Typography sx={{ 
                                                                fontSize: '14px', 
                                                                textAlign: 'left', 
                                                                backgroundColor: '#FFFFFF', 
                                                                padding: '0px 2px', 
                                                                textDecoration: '#AC8312', 
                                                                borderRadius: "4px" 
                                                              }}>
                                                                {driver.driver_id && (
                                                                  <>
                                                                    <span style={{ color: '#9FA3A7' }}>Driver Id: </span>
                                                                    <span style={{ color: '#AC8312' }}>{driver.driver_id}</span>
                                                                  </>
                                                                )}
                                                              </Typography>
                                                              {driver.driver_name && (
                                                                <Typography sx={{ color: '#4E545D', fontSize: '16px' }}>{driver.driver_name}</Typography>
                                                              )}
                                                              {driver.driver_phone_number && (
                                                                <Typography sx={{ color: "#9FA3A7", fontSize: "12px" }}>{driver.driver_phone_number}</Typography>
                                                              )}
                                                            </Grid2>
                                                          </Grid2>
                                    </TableCell>
                                    {driver.shift_timing.map((shift, i) => {
                                        const shiftId = `${driver.driver_id}-${i}`;
                                        return (
                                            <TableCell key={i} sx={{ minWidth: "250px", }}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    backgroundColor: '#F5F5F5',
                                                    padding: '10px',
                                                    backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9FAFB',
                                                    borderRadius: '10px',
                                                }}>
                                                    <ColoredLine color="#CCCDCE" />

                                                    <Box sx={{ flex: 1, marginLeft: '10px',minWidth:"200px"  }}>
                                                        {renderField(shiftId, "shift_id", null, null, `Shift Id :- ${shift.shift_id}`) } 
                                                        {renderField(shiftId, "timing", shift.start, shift.end)}
                                                        {renderField(shiftId, "vehicle", null, null, shift.vehicle_number)}
                                                    </Box>
                                                    <>
                                                        <IconButton
                                                            onClick={(e) => handleMenuClick(e, shift)}
                                                            size="small"
                                                            sx={{
                                                                padding: '4px',
                                                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                                                            }}
                                                        >
                                                            <img
                                                                src={EditHamIcon}
                                                                alt="edit"
                                                                style={{
                                                                    width: '40px',
                                                                    height: '40px',
                                                                    cursor: 'pointer'
                                                                }}
                                                            />
                                                        </IconButton>

                                                        <Menu
                                                            anchorEl={anchorEl2}
                                                            open={Boolean(anchorEl2 && selectedShift?.shift_id === shift.shift_id)}
                                                            onClose={handleMenuClose}
                                                            PaperProps={{
                                                                elevation: 3,
                                                                sx: {
                                                                    borderRadius: '12px',
                                                                    minWidth: '160px',
                                                                    padding: '4px 0',
                                                                    overflow: 'visible',
                                                                    '&:before': {
                                                                        content: '""',
                                                                        display: 'block',
                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        right: 14,
                                                                        width: 10,
                                                                        height: 10,
                                                                        bgcolor: 'background.paper',
                                                                        transform: 'translateY(-50%) rotate(45deg)',
                                                                        zIndex: 0,
                                                                    },
                                                                },
                                                            }}
                                                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                                        >
                                                            <MenuItem
                                                                onClick={() => {
                                                                    if (currentRoleId == 1 || !isShiftExpired(shift)) {
                                                                        handlemodalOpen(shift, driver, i);
                                                                        handleMenuClose();
                                                                    }
                                                                }}
                                                                disabled={currentRoleId != 1 && isShiftExpired(shift)}
                                                                sx={{
                                                                    fontSize: '14px',
                                                                    gap: "30px",
                                                                    '&:hover': {
                                                                        backgroundColor: (currentRoleId != 1 && isShiftExpired(shift)) ? 'transparent' : 'rgba(0, 0, 0, 0.04)'
                                                                    },
                                                                    opacity: (currentRoleId != 1 && isShiftExpired(shift)) ? 0.5 : 1,
                                                                    cursor: (currentRoleId != 1 && isShiftExpired(shift)) ? 'not-allowed' : 'pointer'
                                                                }}
                                                            >
                                                                <ListItemText 
                                                                    primary="Edit" 
                                                                    sx={{ 
                                                                        color: (currentRoleId != 1 && isShiftExpired(shift)) ? '#9CA3AF' : '#6B7280'
                                                                    }} 
                                                                />
                                                                <img
                                                                    src={EditPencil}
                                                                    alt="Edit"
                                                                    style={{
                                                                        width: '16px',
                                                                        height: '16px',
                                                                        opacity: (currentRoleId != 1 && isShiftExpired(shift)) ? 0.5 : 1
                                                                    }}
                                                                />
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={() => {
                                                                    handleDeleteConfirmModalOpen(shift.shift_id);
                                                                }}
                                                                disabled={currentRoleId != 1 && isShiftExpired(shift)}
                                                                sx={{
                                                                    fontSize: '14px',
                                                                    gap: "30px",
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                                                    }
                                                                }}
                                                            >
                                                                <ListItemText primary="Delete" sx={{ color: '#6B7280' }} />
                                                                <img
                                                                    src={Trash}
                                                                    alt="Delete"
                                                                    style={{
                                                                        width: '16px',
                                                                        height: '16px'
                                                                    }}
                                                                />
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={() => {
                                                                    handleViewModalOpen(shift.shift_id);
                                                                }}
                                                                sx={{
                                                                    fontSize: '14px',
                                                                    gap: "30px",
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                                                    }
                                                                }}
                                                            >
                                                                <ListItemText primary="View" sx={{ color: '#6B7280' }} />
                                                                <img
                                                                    src={ViewIcon}
                                                                    alt="View"
                                                                    style={{
                                                                        width: '16px',
                                                                        height: '16px'
                                                                    }}
                                                                />
                                                            </MenuItem>

                                                        </Menu>
                                                    </>
                                                </Box>
                                            </TableCell>
                                        );
                                    })}
                                    {Array.from({ length: maxShifts - driver.shift_timing.length }).map((_, i) => (
                                        <TableCell key={`empty-${i}`} align="center">
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                backgroundColor: '#F5F5F5',
                                                padding: '10px',
                                                backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9FAFB',
                                                borderRadius: '10px'
                                            }}>
                                                <ColoredLine color="#C71F1F" />
                                                <Box sx={{ flex: 1, marginLeft: '10px' }}>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 500, color: '#4E545D' }}>
                                                        Unavailable
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    ))}

                                    <TableCell>
                                        <Box sx={{ position: 'relative' }}>
                                            <IconButton
                                                onClick={(e) => handlemaineditclick(e, driver)} // ✅ pass driver here
                                                size="small"
                                                sx={{
                                                    padding: '4px',
                                                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                                                }}
                                            >
                                                <Tooltip title="Edit or View Shifts">
                                                <img
                                                    src={ActionbuttonSvg}
                                                    alt="actions"
                                                    style={{
                                                        width: '40px',
                                                        height: '40px',
                                                        cursor: 'pointer'
                                                    }}
                                                />
                                                </Tooltip>
                                            </IconButton>
                                            <Menu
                                                anchorEl={maineditclick}
                                                open={Boolean(maineditclick)}
                                                onClose={() => setmaineditclick(null)}
                                                PaperProps={{
                                                    elevation: 3,
                                                    sx: {
                                                        borderRadius: '12px',
                                                        minWidth: '80px',
                                                        padding: '4px 0',
                                                        overflow: 'visible',
                                                        '&:before': {
                                                            content: '""',
                                                            display: 'block',
                                                            position: 'absolute',
                                                            top: 0,
                                                            right: 14,
                                                            width: 10,
                                                            height: 10,
                                                            bgcolor: 'background.paper',
                                                            transform: 'translateY(-50%) rotate(45deg)',
                                                            zIndex: 0,
                                                        },
                                                    },
                                                }}
                                            >
                                                <MenuItem
                                                    onClick={() => {
                                                        handleOpenAddModal(selectedDriver); // ✅ pass driver to modal
                                                        setShiftType("edit");
                                                        setmaineditclick(null);
                                                    }}
                                                    sx={{ gap: "10px" }}
                                                >
                                                    <img src={EditPencil} alt="Edit" style={{ width: 16, height: 16 }} />
                                                    <span>Edit</span>
                                                </MenuItem>

                                                <MenuItem
                                                    onClick={() => {
                                                        handleopenViewModal(selectedDriver); // ✅ for view too
                                                        setShiftType("view");
                                                        setmaineditclick(null);
                                                    }}
                                                    sx={{ gap: "10px" }}
                                                >
                                                    <img src={ViewIcon} alt="View" style={{ width: 16, height: 16 }} />
                                                    <span>View</span>
                                                </MenuItem>
                                            </Menu>

                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {(openAddModal || openViewModal) && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,  // This will align it to the right
                    height: '100vh',  // Use viewport height
                    width: '50%',
                    top: 65,
                    paddingBottom: '60px',
                    backgroundColor: '#f9f9f9',
                    zIndex: 1000,
                    overflowY: 'auto',
                    padding: '20px',
                    margin: 0  // Remove any default margins
                }}>
                    <Box onClose={handleClose}>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{ position: 'absolute', top: '-15px', left: '1px', color: '#333', zIndex: 10, }}
                            >
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{
                                    padding: '20px', minWidth: '60px',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'
                                }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                                    <Typography style={{ marginBottom: '20px', fontWeight: '500', fontSize: '24px' }}>
                                        {shiftType === "edit"
                                            ? 'Edit Shift'
                                            : shiftType === "view"
                                                ? 'View Shift'
                                                : 'Add Shift'
                                        }
                                    </Typography>
                                    <Tooltip title="Edit" sx={{ cursor: 'pointer',fontSize: '16px' }}>
                                    {shiftType == "view" ? <img onClick={() => setShiftType("edit")} src={EditSvg} alt="edit" style={{ width: '20px', height: '20px', cursor: 'pointer' }} /> : null}
                                    </Tooltip>
                                </Box>
                                <Grid2 item>

                                    <Box sx={{
                                        position: 'relative',
                                        mt: 1,
                                        mb: 2,
                                        backgroundColor: '#f9f9f9',
                                        padding: '10px',
                                        borderRadius: '12px'
                                    }}>
                                        {(shiftType == "edit" || shiftType == "view") ? <Grid2 item sx={{ mb: 2 }}>
                                            <Box sx={{ width: '100%' }}>
                                                <Label sx={{ mb: 4 }}>Driver Name </Label>
                                                <TextField

                                                    fullWidth
                                                    variant="outlined"
                                                    value={editDetails?.driver_name || ''}

                                                    disabled
                                                    InputProps={{
                                                        style: {
                                                            height: '52px',
                                                            marginTop: '8px',
                                                            borderRadius: '12px',
                                                            backgroundColor: '#fff'
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </Grid2> : 
                                        <Grid2>
                                        <Box sx={{ width: '100%' }}>
                                            <Box sx={{ mb: 1 }}>
                                                <Label>Driver Name</Label>
                                            </Box>
                                            <Select
                                                fullWidth
                                                value={newShiftDriverId || newShift.driver_id || ''}
                                                onChange={(e) => {
                                                    const selectedDriver = driversData.find(driver => driver.driver_id === e.target.value);
                                                    setNewShiftDriverId(e.target.value);
                                                    handleNewShiftChange('driver_id', e.target.value);
                                                    handleNewShiftChange('driver_name', selectedDriver?.driver_name || '');
                                                }}
                                                placeholder="Select Driver"
                                                renderValue={(selected) => {
                                                    if (!selected) return '';
                                                    const drv = driversData.find(d => d.driver_id === selected) || drivers.find(d => d.driver_id === selected);
                                                    return drv ? `${drv.driver_name}${drv.vehicle_no ? ` (${drv.vehicle_no})` : ''}` : selected;
                                                }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: "12px",
                                                        height: "48px",
                                                        backgroundColor: "#fff",
                                                    },
                                                    '& .MuiSelect-select': {
                                                        padding: '10px 14px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    },
                                                }}
                                            >
                                                <MenuItem value="">All</MenuItem>
                                                {driversData
                                                ?.filter(driver => !drivers.some(d => d.driver_id === driver.driver_id))
                                                ?.sort((a, b) => {
                                                    if (a.driver_verification_status === 1 && b.driver_verification_status !== 1) return -1;
                                                    if (a.driver_verification_status !== 1 && b.driver_verification_status === 1) return 1;
                                                    return 0;
                                                })
                                                ?.map((driver) => (
                                                    <MenuItem
                                                        key={driver.driver_id}
                                                        value={driver.driver_id}
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            padding: '8px 16px',
                                                        }}
                                                        disabled={driver.driver_verification_status != 1}
                                                    >
                                                        <Box>
                                                            <Typography sx={{ fontWeight: 500 }}>
                                                                {driver.driver_name} 
                                                                {driver.vehicle_no && (
                                                                    <Typography component="span" variant="caption" color="textSecondary" sx={{ ml: 1 }}>
                                                                        ({driver.vehicle_no})
                                                                    </Typography>
                                                                )}
                                                                {driver.driver_verification_status != 1 && (
                                                                    <Typography component="span" variant="caption" color="red" sx={{ ml: 1 }}>
                                                                        (Not Verified)
                                                                    </Typography>
                                                                )}
                                                            </Typography>
                                                        </Box>
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid2>
                                        }

                                    </Box>
                                    <Box sx={{
                                        position: 'relative',
                                        mt: 1,
                                        mb: 2,
                                        backgroundColor: '#f9f9f9',
                                        padding: '10px',
                                        borderRadius: '12px'
                                    }}>
                                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                                            Shift Details
                                        </Typography>

                                        {editDetails?.shift_timing?.map((shift, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    mt: 2,
                                                    pl: 2,
                                                    pt: 2,
                                                    pb: 2,
                                                    borderRadius: "10px",
                                                    backgroundColor: "#FFFFFF",
                                                }}
                                            >   
                                            <Grid2 container spacing={2} sx={{ mt: 1, mb: 2 }}>
                                                        <Grid2 item size={6}>
                                                            <Label>Start Date</Label>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs} disabled>
                                                                <DemoContainer
                                                                    components={['DatePicker']}
                                                                    sx={{
                                                                        '& .MuiStack-root': {
                                                                            padding: 0
                                                                        }
                                                                    }}
                                                                >
                                                                    <DatePicker
                                                                        sx={{
                                                                            width: '100%',
                                                                            '& .MuiOutlinedInput-root': {
                                                                                height: '48px',
                                                                                borderRadius: '8px',
                                                                                backgroundColor: '#FFFFFF',
                                                                                border: returnDateError ? '1px solid red' : 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                fontSize: '16px',
                                                                                padding: '0px 14px',
                                                                                color: returnDateError ? 'red' : 'inherit',
                                                                            },
                                                                        }}
                                                                        value={dateTime}
                                                                        onChange={(newValue) => {
                                                                            setDateTime(newValue);
                                                                        }}
                                                                        disabled={true}
                                                                        format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"} 
                                                                        slotProps={{
                                                                            textField: {
                                                                                fullWidth: true,
                                                                                placeholder: 'Select date',
                                                                            },
                                                                        }}
                                                                    />
                                                                    {dateTimeError && (
                                                                        <Typography
                                                                            color="error"
                                                                            variant="caption"
                                                                            sx={{ display: 'block', mt: 0.5 }}
                                                                        >
                                                                            {dateTimeError}
                                                                        </Typography>
                                                                    )}
                                                                </DemoContainer>
                                                            </LocalizationProvider>


                                                        </Grid2>
                                                        <Grid2 item size={6}>
                                                            <Label>End Date</Label>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs} disabled>
                                                                <DemoContainer
                                                                    components={['DatePicker']}
                                                                    sx={{
                                                                        '& .MuiStack-root': {
                                                                            padding: 0
                                                                        }
                                                                    }}
                                                                >
                                                                    <DatePicker
                                                                        sx={{
                                                                            width: '100%',
                                                                            '& .MuiOutlinedInput-root': {
                                                                                height: '48px',
                                                                                borderRadius: '8px',
                                                                                backgroundColor: '#FFFFFF',
                                                                                border: returnDateError ? '1px solid red' : 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                fontSize: '16px',
                                                                                padding: '0px 14px',
                                                                                color: returnDateError ? 'red' : 'inherit',
                                                                            },
                                                                        }}
                                                                        minDate={dayjs(mainselectedDate)}
                                                                        maxDate={dayjs(mainselectedDate).add(1,'day')}
                                                                        value={dayjs(shift.end).local()}
                                                                        onChange={(newValue) => {
                                                                            setEndDateTime(newValue);
                                                                        }}
                                                                        disabled={shiftType === "view" || (currentRoleId != 1 && isShiftExpired(editableShifts[index])) }

                                                                        format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}  // 👈 date only
                                                                        slotProps={{
                                                                            textField: {
                                                                                fullWidth: true,
                                                                                placeholder: 'Select date',
                                                                            },
                                                                        }}
                                                                    />
                                                                    {dateTimeError && (
                                                                        <Typography
                                                                            color="error"
                                                                            variant="caption"
                                                                            sx={{ display: 'block', mt: 0.5 }}
                                                                        >
                                                                            {dateTimeError}
                                                                        </Typography>
                                                                    )}
                                                                </DemoContainer>
                                                            </LocalizationProvider>


                                                        </Grid2>
                                                    </Grid2>
                                                <Grid2 container spacing={2} alignItems="center">
                                                    <Grid2 item size={1}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{
                                                                fontWeight: 500,
                                                                color: "#333",
                                                                textAlign: "left",
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            Shift {index + 1}
                                                        </Typography>
                                                    </Grid2>

                                                    <Grid2 item size={11} sx={{display:'flex', alignItems:'center'}}>
                                                        {/* <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: '100%' }}> */}
                                                            <Grid2 item size={5.5} sx={{marginLeft:"20px"}}>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DemoContainer components={['DatePicker']} sx={{ '& .MuiStack-root': { padding: 0 } }}>
                                                                        <TimePicker
                                                                            label="Start Time"
                                                                            // value={editableShifts?.[index]?.start ? dayjs(editableShifts[index].start) : null}
                                                                            value={
                                                                                editableShifts?.[index]?.start
                                                                                ? timeStringToDayjs(editableShifts[index].start)
                                                                                : null
                                                                            }
                                                                            onChange={(newValue) => {
                                                                                if (!newValue || !newValue.isValid()) return;

                                                                                const updatedShifts = [...editableShifts];

                                                                                // Use the date from existing end time, or fallback to today
                                                                                const datePart = editableShifts[index].end 
                                                                                    ? dayjs(editableShifts[index].end).format('YYYY-MM-DD') 
                                                                                    : dayjs().format('YYYY-MM-DD');

                                                                                // Combine selected time with date and convert to UTC ISO
                                                                            const startISO = dayjs(`${datePart} ${newValue.format('HH:mm:ss')}`, 'YYYY-MM-DD HH:mm:ss')
                                                                                .subtract(utcOffset,'minute')
                                                                                .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'); // includes milliseconds
                                                                                updatedShifts[index] = {
                                                                                    ...updatedShifts[index],
                                                                                    start: startISO, // now in same format as end
                                                                                };
                                                                                setEditableShifts(updatedShifts);
                                                                            }}

                                                                            disabled={shiftType === "view" || (currentRoleId != 1 && isShiftExpired(editableShifts[index]))}                                                                           sx={{
                                                                                width: '100%',
                                                                                '& .MuiOutlinedInput-root': { height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF', border: returnDateError ? '1px solid red' : 'none' },
                                                                                '& .MuiInputBase-input': { fontSize: '16px', padding: '0px 14px', color: returnDateError ? 'red' : 'inherit' },
                                                                            }}
                                                                            slotProps={{ textField: { fullWidth: true, placeholder: 'Select time' } }}
                                                                        />
                                                                        {/* {dateTimeError && <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>{dateTimeError}</Typography>} */}
                                                                    </DemoContainer>
                                                                </LocalizationProvider>
                                                            </Grid2>
                                                            <Grid2 item size={1}>
                                                                <Typography sx={{ color: "#555", fontWeight: 500, whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                                    to
                                                                </Typography>
                                                            </Grid2>

                                                            <Grid2 item size={5.5}>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DemoContainer components={['DatePicker']} sx={{ '& .MuiStack-root': { padding: 0 } }}>
                                                                        

                                                                        <TimePicker
                                                                            label="End Time"
                                                                            // value={editableShifts?.[index]?.end ? dayjs(editableShifts[index].end) : null}
                                                                            value={
                                                                                editableShifts?.[index]?.end
                                                                                    ? timeStringToDayjs(editableShifts[index].end)
                                                                                    : null
                                                                            }
                                                                            
                                                                            // onChange={(newValue) => {
                                                                            //     const updatedShifts = [...editableShifts];
                                                                            //     console.log(updatedShifts,"updatedShifts")
                                                                            //     updatedShifts[index] = {
                                                                            //         ...updatedShifts[index],
                                                                            //         end: newValue ? newValue.format('HH:mm:ss') : null,
                                                                            //     };
                                                                            //     setEditableShifts(updatedShifts);
                                                                            // }}
                                                                            onChange={(newValue) => {
                                                                                if (!newValue || !newValue.isValid()) return;

                                                                                const updatedShifts = [...editableShifts];

                                                                                // Use the date from existing end time, or fallback to today
                                                                                const datePart = editableShifts[index].end 
                                                                                    ? dayjs(editableShifts[index].end).format('YYYY-MM-DD') 
                                                                                    : dayjs().format('YYYY-MM-DD');

                                                                                // Combine selected time with date and convert to UTC ISO
                                                                            const endISO = dayjs(`${datePart} ${newValue.format('HH:mm:ss')}`, 'YYYY-MM-DD HH:mm:ss')
                                                                                .subtract(utcOffset,'minute')
                                                                                .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'); // includes milliseconds

                                                                                updatedShifts[index] = {
                                                                                    ...updatedShifts[index],
                                                                                    end: endISO, // now in same format as end
                                                                                };
                                                                                setEditableShifts(updatedShifts);
                                                                            }}
                                                                            disabled={shiftType === "view" || (currentRoleId != 1 && isShiftExpired(editableShifts[index]))}
                                                                            sx={{
                                                                                width: '100%',
                                                                                '& .MuiOutlinedInput-root': { height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF', border: returnDateError ? '1px solid red' : 'none' },
                                                                                '& .MuiInputBase-input': { fontSize: '16px', padding: '0px 14px', color: returnDateError ? 'red' : 'inherit' },
                                                                            }}
                                                                            slotProps={{ textField: { fullWidth: true, placeholder: 'Select time' } }}
                                                                        />
                                                                        {/* {dateTimeError && <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>{dateTimeError}</Typography>} */}
                                                                    </DemoContainer>
                                                                </LocalizationProvider>
                                                            </Grid2>
                                                        {/* </Box> */}
                                                    </Grid2>

                                                    <Grid2 item size={1}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{
                                                                fontWeight: 500,
                                                                color: "#333",
                                                                textAlign: "left",
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            Vehicle
                                                        </Typography>
                                                    </Grid2>

                                                    <Grid2 item size={10.5}>
                                                            {editingShiftId === index ? (
                                                                <>
                                                                    <Select
                                                                        fullWidth
                                                                        value={editableShifts?.[index]?.vehicle_id || ''}
                                                                        onChange={(e) => {
                                                                            const selectedVehicle = availableVehicle.find(v => v.vehicle_id === e.target.value);
                                                                            const updatedShifts = [...editableShifts];
                                                                            updatedShifts[index] = {
                                                                                ...updatedShifts[index], // Preserve all existing fields
                                                                                vehicle_id: selectedVehicle?.id ?? e.target.value,
                                                                                vehicle_number: selectedVehicle?.vehicle_number ?? selectedVehicle?.vehicle_no ?? updatedShifts[index].vehicle_number,
                                                                                vehicle_info: selectedVehicle ?? updatedShifts[index].vehicle_info,
                                                                                start: updatedShifts[index].start, // Explicitly preserve start
                                                                                end: updatedShifts[index].end,     // Explicitly preserve end
                                                                            };
                                                                            setEditableShifts(updatedShifts);
                                                                        }}
                                                                        disabled={shiftType === "view" || (currentRoleId != 1 && isShiftExpired(editableShifts[index]))}
                                                                        sx={{ minWidth: '330px', '& .MuiOutlinedInput-root': { borderRadius: "12px", backgroundColor: "#fafafa", height: "48px" }, '& .MuiSelect-select': { padding: '12px 32px 12px 14px' } }}
                                                                        startAdornment={<InputAdornment position="start"><IconButton edge="start" disabled><img src={DirectionsCarIcon} alt="Vehicle" style={{ width: 20, height: 20 }} /></IconButton></InputAdornment>}
                                                                    >
                                                                        <MenuItem value="" disabled>Select Vehicle</MenuItem>
                                                                        {availableVehicle.map((vehicle) => (
                                                                            <MenuItem key={vehicle.vehicle_id} value={vehicle.vehicle_id}>
                                                                                <Box>
                                                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                                                        {vehicle.brand} {vehicle.model_name}
                                                                                    </Typography>
                                                                                    <Typography variant="caption" color="textSecondary">
                                                                                        {vehicle.vehicle_number}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <TextField
                                                                        fullWidth
                                                                        disabled={shiftType === "view" || (currentRoleId != 1 && isShiftExpired(editableShifts[index]))}
                                                                        value={editableShifts?.[index]?.vehicle_number || ""}
                                                                        onChange={(e) => {
                                                                            const updatedShifts = [...editableShifts];
                                                                            updatedShifts[index] = {
                                                                                ...updatedShifts[index],
                                                                                vehicle_number: e.target.value,
                                                                                vehicle_id: '' // clear id when typing free text
                                                                            };
                                                                            setEditableShifts(updatedShifts);
                                                                        }}
                                                                        onFocus={(e) => {
                                                                            if (!suppressVehicleMenuOpen && shiftType !== "view") setVehicleMenu({ anchor: e.currentTarget, index });
                                                                        }}
                                                                        onClick={(e) => {
                                                                            if (!suppressVehicleMenuOpen && shiftType !== "view") setVehicleMenu({ anchor: e.currentTarget, index });
                                                                        }}
                                                                        placeholder="Enter vehicle number or pick driver"
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <InputAdornment position="start">
                                                                                    <IconButton edge="start" disabled>
                                                                                        <img src={DirectionsCarIcon} alt="Vehicle" style={{ width: 20, height: 20 }} />
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                        sx={{
                                                                            marginLeft: "20px",
                                                                            '& .MuiOutlinedInput-root': {
                                                                                borderRadius: "12px",
                                                                                backgroundColor: "#fafafa",
                                                                                height: "48px",
                                                                                width: "100%",
                                                                                minWidth: "540px"
                                                                            },
                                                                            '& .MuiInputBase-input': { fontSize: "16px" }
                                                                        }}
                                                                    />
                                                                    <Menu
                                                                        anchorEl={vehicleMenu.anchor}
                                                                        open={Boolean(vehicleMenu.anchor && vehicleMenu.index === index)}
                                                                        onClose={() => setVehicleMenu({ anchor: null, index: null })}
                                                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                                                        PaperProps={{ sx: { maxHeight: 320, width: 500 } }}
                                                                    >
                                                                        {availableVehicle && availableVehicle.length > 0 ? (
                                                                            availableVehicle.map((drv) => (
                                                                                <MenuItem
                                                                                    key={drv.driver_id}
                                                                                    sx={{
                                                                                        display: 'flex',
                                                                                        justifyContent: 'space-between',
                                                                                        padding: '8px 16px',
                                                                                        width: '100%'
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        const updatedShifts = [...editableShifts];
                                                                                        const candidateVehicleId = drv.id;
                                                                                        const candidateVehicleNumber = drv.vehicle_no ?? drv.vehicle_number ?? drv.client_vehicle?.vehicle_number ?? drv.vehicle?.number ?? null;
                                                                                        updatedShifts[index] = {
                                                                                            ...updatedShifts[index], // Preserve all existing fields
                                                                                            driver_id: drv.driver_id,
                                                                                            driver_name: drv.driver_name,
                                                                                            vehicle_id: candidateVehicleId ?? updatedShifts[index].id,
                                                                                            vehicle_number: candidateVehicleNumber ?? updatedShifts[index].vehicle_number,
                                                                                            driver_info: drv,
                                                                                            start: updatedShifts[index].start, // Explicitly preserve start
                                                                                            end: updatedShifts[index].end,     // Explicitly preserve end
                                                                                        };
                                                                                        setEditableShifts(updatedShifts);
                                                                                        setVehicleMenu({ anchor: null, index: null });
                                                                                        setSuppressVehicleMenuOpen(true);
                                                                                        setTimeout(() => setSuppressVehicleMenuOpen(false), 300);
                                                                                    }}
                                                                                >
                                                                                    <Box>
                                                                                        <Typography variant="body1" sx={{ fontWeight: 500 }}>{drv.model_name}</Typography>
                                                                                        <Typography variant="caption" color="textSecondary">({drv.brand}) {drv.vehicle_no ?? drv.vehicle_number}</Typography>
                                                                                    </Box>
                                                                                </MenuItem>
                                                                            ))
                                                                        ) : (
                                                                            <MenuItem disabled>No drivers</MenuItem>
                                                                        )}
                                                                    </Menu>
                                                                </>
                                                            )

                                                            }
                                                        {/* </Box> */}
                                                    </Grid2>
                                                    <Accordion
                                                    disableGutters
                                                    onClick={() => {
                                                        fetchShiftRideDetails(shift?.shift_id);
                                                    }}
                                                    sx={{
                                                        border: "none",
                                                        boxShadow: "none",
                                                        borderRadius: "12px",
                                                        width: "97%",
                                                        marginBottom:'10px',

                                                        "&::before": { display: "none" },
                                                    }}
                                                    >
                                                    <AccordionSummary
                                                        expandIcon={<img src={ExpandMoreIcon} alt="Expand" sx={{rotate: "180deg"}} />}
                                                        aria-controls="panel1-content"
                                                        id="panel1-header"
                                                        sx={{
                                                        px: 0,
                                                        "& .MuiAccordionSummary-content": { px: 0, m: 0 },
                                                        }}
                                                    >
                                                        <Typography component="span" sx={{ fontWeight: 600 }}>
                                                        Ride Details
                                                        </Typography>
                                                    </AccordionSummary>
                                                    {ShiftRideDetails?.length === 0 ? (
                                                        <Typography variant="body1" sx={{ display:'flex',fontWeight: 500,justifyContent:'center',alignItems:'center',width:'100%' }}>
                                                            No rides found for this shift.
                                                        </Typography>
                                                    ) : (
                                                    ShiftRideDetails?.map((ride, index) => (
                                                        <AccordionDetails key={ride.ride_id} sx={{ p: 0 }}>
                                                            <Box
                                                                sx={{
                                                                    borderRadius: "12px",
                                                                    backgroundColor: "#f9f9f9",
                                                                    p: 2,
                                                                }}
                                                            >
                                                                {/* Ride ID + Title */}
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        mb: 2,
                                                                    }}
                                                                >
                                                                    <Typography variant="h6" sx={{ fontWeight: 400 }}>
                                                                        {ride.status === 2 ? "Assigned" : ride.status === 3 ? "Arrived" : ride.status === 5 ? "Started" : "Ride"}
                                                                    </Typography>
                                                                        <Box sx={{ display: 'flex', gap: 2 }}>
                                                                        {ride.ride_id &&
                                                                        <Typography
                                                                            sx={{
                                                                                color: "#2962ff",
                                                                                border: "1px solid #2962ff",
                                                                                borderRadius: "8px",
                                                                                px: 1.5,
                                                                                py: 0.5,
                                                                                fontWeight: 500,
                                                                                fontSize: "14px",
                                                                            }}
                                                                        >
                                                                            Ride ID : {ride.ride_id}
                                                                        </Typography>}
                                                                        <Typography
                                                                            sx={{
                                                                                color: "#2962ff",
                                                                                border: "1px solid #2962ff",
                                                                                borderRadius: "8px",
                                                                                px: 1.5,
                                                                                py: 0.5,
                                                                                fontWeight: 500,
                                                                                fontSize: "14px",
                                                                            }}
                                                                        >
                                                                            Engagement ID : {ride.engagement_id}
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>

                                                                {/* Pickup and Drop */}
                                                                <Box
                                                                    sx={{
                                                                        backgroundColor: "#fff",
                                                                        borderRadius: "12px",
                                                                        p: 2,
                                                                        mb: 2,
                                                                    }}
                                                                >
                                                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                                                        <img src={PickUpIcon} alt="Pickup" height={20} width={20} />
                                                                        <Typography variant="body1" sx={{ fontWeight: 400, ml: 1 }}>
                                                                            {ride.pickup_address || 'N/A'}
                                                                        </Typography>
                                                                        {ride.pickup_time && (
                                                                            <Box sx={{ ml: "auto", backgroundColor: "#f4f4f4", px: 1.5, py: 0.5, borderRadius: "8px" }}>
                                                                                <Typography sx={{ fontWeight: 400 }}>
                                                                                {new Date(ride.pickup_time).toLocaleTimeString('en-US', {
                                                                                    hour: '2-digit',
                                                                                    minute: '2-digit',
                                                                                    hour12: true
                                                                                })}
                                                                                </Typography>
                                                                            </Box>
                                                                        )}
                                                                    </Box>
                                                                    
                                                                    <Divider sx={{ borderStyle: "dashed", my: 1, ml: 3 }} />

                                                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                        <img src={DropIcon} alt="Drop" height={20} width={20} />
                                                                        <Typography variant="body1" sx={{ fontWeight: 400, ml: 1 }}>
                                                                            {ride.drop_address || 'N/A'}
                                                                        </Typography>
                                                                        {ride.drop_time && (
                                                                            <Box sx={{ ml: "auto", backgroundColor: "#f4f4f4", px: 1.5, py: 0.5, borderRadius: "8px" }}>
                                                                                <Typography sx={{ fontWeight: 400 }}>
                                                                                    {new Date(ride.drop_time).toLocaleTimeString('en-US', {
                                                                                    hour: '2-digit',
                                                                                    minute: '2-digit',
                                                                                    hour12: true
                                                                                })}
                                                                                </Typography>
                                                                            </Box>
                                                                        )}
                                                                    </Box>
                                                                </Box>

                                                                {/* Vehicle Info */}
                                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                    <img src={BlueCarIcon} alt="Vehicle" height={60} width={60} />
                                                                    <Box>
                                                                        <Typography variant="subtitle1" sx={{ fontWeight: 500, ml: 1, color: "#4E545D" }}>
                                                                            {ride.vehicle_number || 'N/A'}
                                                                        </Typography>
                                                                        <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                                                                            {VehicleTypes[ride.vehicle_type]}
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </AccordionDetails>
                                                    )))}
                                                    </Accordion>
                                                        {shiftHasChanged(index) && (
                                                    <Grid2 item xs={12} md={9} sx={{ marginLeft: "auto", display: 'flex', justifyContent: 'center', gap: 2.6, mt: 1 }}>
                                                            <>
                                                                <Button variant="contained" size="small" disabled={shiftType === "view" || (currentRoleId != 1 && isShiftExpired(editableShifts[index]))} onClick={() => handleSaveShift(index)} sx={{ height: '40px', minWidth: '80px', textTransform: 'none', backgroundColor: '#2563EB', '&:hover': { backgroundColor: '#1D4ED8' } }}>Save</Button>
                                                                <Button variant="outlined" size="small" disabled={shiftType === "view" || (currentRoleId != 1 && isShiftExpired(editableShifts[index]))} onClick={() => handleCancelShiftEdit(index)} sx={{ height: '40px', minWidth: '80px', textTransform: 'none', color: '#6B7280', borderColor: '#D1D5DB' }}>Cancel</Button>
                                                            </>
                                                    </Grid2>
                                                        )}
                                                </Grid2>
                                            </Box>
                                        ))}

                                        {showAddShiftForm && (
                                            <Box
                                                sx={{
                                                    mt: 2,
                                                    p: 2,
                                                    borderRadius: "10px",
                                                    backgroundColor: "#FFFFFF",
                                                    border: "1px dashed #9c27b0",
                                                }}
                                            >
                                                <Grid2 spacing={2} alignItems="center">
                                                    <Grid2 container spacing={2} sx={{ mt: 1, mb: 2 }}>
                                                    <Grid2 item size={6}>
                                                        <Label>Start Date</Label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs} disabled>
                                                            <DemoContainer
                                                                components={['DatePicker']}
                                                                sx={{
                                                                    '& .MuiStack-root': {
                                                                        padding: 0
                                                                    }
                                                                }}
                                                            >
                                                                <DatePicker
                                                                    sx={{
                                                                        width: '100%',
                                                                        '& .MuiOutlinedInput-root': {
                                                                            height: '48px',
                                                                            borderRadius: '8px',
                                                                            backgroundColor: '#FFFFFF',
                                                                            border: returnDateError ? '1px solid red' : 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            fontSize: '16px',
                                                                            padding: '0px 14px',
                                                                            color: returnDateError ? 'red' : 'inherit',
                                                                        },
                                                                    }}
                                                                    value={dateTime}
                                                                    onChange={(newValue) => {
                                                                        setDateTime(newValue);
                                                                    }}
                                                                    disabled={true}
                                                                    format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}  // 👈 date only
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            placeholder: 'Select date',
                                                                        },
                                                                    }}
                                                                />
                                                                {dateTimeError && (
                                                                    <Typography
                                                                        color="error"
                                                                        variant="caption"
                                                                        sx={{ display: 'block', mt: 0.5 }}
                                                                    >
                                                                        {dateTimeError}
                                                                    </Typography>
                                                                )}
                                                            </DemoContainer>
                                                        </LocalizationProvider>


                                                    </Grid2>
                                                    <Grid2 item size={6}>
                                                        <Label>End Date</Label>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs} disabled>
                                                            <DemoContainer
                                                                components={['DatePicker']}
                                                                sx={{
                                                                    '& .MuiStack-root': {
                                                                        padding: 0
                                                                    }
                                                                }}
                                                            >
                                                                <DatePicker
                                                                    sx={{
                                                                        width: '100%',
                                                                        '& .MuiOutlinedInput-root': {
                                                                            height: '48px',
                                                                            borderRadius: '8px',
                                                                            backgroundColor: '#FFFFFF',
                                                                            border: returnDateError ? '1px solid red' : 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            fontSize: '16px',
                                                                            padding: '0px 14px',
                                                                            color: returnDateError ? 'red' : 'inherit',
                                                                        },
                                                                    }}
                                                                    minDate={dayjs(mainselectedDate)}
                                                                    maxDate={dayjs(mainselectedDate).add(1,'day')}
                                                                    value={newendDateTime}
                                                                    onChange={(newValue) => {
                                                                        setNewEndDateTime(newValue);
                                                                    }}

                                                                    format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}  // 👈 date only
                                                                    slotProps={{
                                                                        textField: {
                                                                            fullWidth: true,
                                                                            placeholder: 'Select date',
                                                                        },
                                                                    }}
                                                                />
                                                                {dateTimeError && (
                                                                    <Typography
                                                                        color="error"
                                                                        variant="caption"
                                                                        sx={{ display: 'block', mt: 0.5 }}
                                                                    >
                                                                        {dateTimeError}
                                                                    </Typography>
                                                                )}
                                                            </DemoContainer>
                                                        </LocalizationProvider>


                                                    </Grid2>
                                                    </Grid2>
                                                    {/* Right Side - All Details */}
                                                    <Grid2 container spacing={2} alignItems="center">
                                                        
                                                        <Grid2 item size={1.5}>
                                                            <Typography
                                                                variant="subtitle1"
                                                                sx={{
                                                                    fontWeight: 500,
                                                                    color: "#333",
                                                                    textAlign: "left",
                                                                    whiteSpace: 'nowrap',
                                                                    mr: 3

                                                                }}
                                                            >
                                                                {shiftType === "add" ? `Shift ${newShiftCounter}` : `Shift ${editDetails?.shift_timing?.length + 1}`}                                                                    </Typography>
                                                        </Grid2>
                                                        {/* Start Time */}
                                                        {/* <Grid2 container item size={11}> */}
                                                        <Grid2 item size={5}>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                                <DemoContainer
                                                                    components={['DatePicker']}
                                                                    sx={{
                                                                        '& .MuiStack-root': {
                                                                            padding: 0
                                                                        }
                                                                    }}
                                                                >
                                                                    <TimePicker
                                                                        label="Start Time"
                                                                        value={newShift.start_time ? timeStringToDayjs(newShift.start_time)?.subtract(utcOffset, 'minute') : null}
                                                                        // onChange={(newValue) => {
                                                                        //     if (newValue) {
                                                                        //         // Use format() with the timezone offset included
                                                                        //         const localTimeString = newValue.format('HH:mm:ss');
                                                                        //         handleNewShiftChange('start_time', localTimeString);
                                                                        //     }
                                                                        // }}
                                                                        onChange={(newValue) => {
                                                                                if (!newValue || !newValue.isValid()) return;

                                                                                // Combine date + selected time
                                                                                const combined = dayjs(`${dateTime.format('YYYY-MM-DD')} ${newValue.format('HH:mm:ss')}`, 'YYYY-MM-DD HH:mm:ss');

                                                                                // Apply your UTC offset
                                                                                const utcOffsetVal = parseInt(localStorage.getItem('utc_offset') || '240', 10);
                                                                                const formattedForBackend = combined.subtract(utcOffsetVal, 'minute').format('YYYY-MM-DD HH:mm:ss'); // note space, not T

                                                                                handleNewShiftChange('start_time', formattedForBackend);
                                                                            }}

                                                                        sx={{
                                                                            width: '100%',
                                                                            '& .MuiOutlinedInput-root': {
                                                                                height: '48px',
                                                                                borderRadius: '8px',
                                                                                backgroundColor: '#FFFFFF',
                                                                                border: returnDateError ? '1px solid red' : 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                fontSize: '16px',
                                                                                padding: '0px 14px',
                                                                                color: returnDateError ? 'red' : 'inherit',
                                                                            },
                                                                        }}
                                                                        slotProps={{
                                                                            textField: {
                                                                                fullWidth: true,
                                                                                placeholder: 'Select Time',
                                                                            },
                                                                        }}
                                                                    />
                                                                    {dateTimeError && (
                                                                        <Typography
                                                                            color="error"
                                                                            variant="caption"
                                                                            sx={{ display: 'block', mt: 0.5 }}
                                                                        >
                                                                            {dateTimeError}
                                                                        </Typography>
                                                                    )}
                                                                </DemoContainer>
                                                            </LocalizationProvider>
                                                        </Grid2>

                                                        {/* To Text */}
                                                        <Grid2 item size={0.5}>
                                                            <Typography sx={{ color: "#555", fontWeight: 500, lineHeight: '48px',textAlign:'center' }}>to</Typography>
                                                        </Grid2>

                                                        {/* End Time */}
                                                        <Grid2 item size={5}>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DemoContainer
                                                                    components={['DatePicker']}
                                                                    sx={{
                                                                        '& .MuiStack-root': {
                                                                            padding: 0
                                                                        }
                                                                    }}
                                                                >
                                                                    <TimePicker
                                                                        label="End Time"
                                                                        value={newShift.end_time ? timeStringToDayjs(newShift.end_time)?.subtract(utcOffset, 'minute') : null}
                                                                        // onChange={(newValue) => {
                                                                        //     if (newValue) {
                                                                        //         console.log(newValue,"newValue")
                                                                        //         // Use format() with the timezone offset included
                                                                        //         const localTimeString = newValue.format('HH:mm:ss');
                                                                        //         console.log(localTimeString,"localTimeString")
                                                                        //         handleNewShiftChange('end_time', localTimeString);
                                                                        //     }
                                                                        // }}
                                                                        onChange={(newValue) => {
                                                                            if (!newValue || !newValue.isValid()) return;

                                                                            // Combine date + selected time
                                                                            const combined = dayjs(`${dateTime.format('YYYY-MM-DD')} ${newValue.format('HH:mm:ss')}`, 'YYYY-MM-DD HH:mm:ss');

                                                                            // Apply your UTC offset
                                                                            const utcOffsetVal = parseInt(localStorage.getItem('utc_offset') || '240', 10);
                                                                            const formattedForBackend = combined.subtract(utcOffsetVal, 'minute').format('YYYY-MM-DD HH:mm:ss'); // note space, not T

                                                                            handleNewShiftChange('end_time', formattedForBackend);
                                                                        }}

                                                                        sx={{
                                                                            width: {
                                                                                xs: '100%',    // full width on extra-small screens (mobile)
                                                                                sm: '100%',    // full width on small screens
                                                                                md: '100%',   // fixed width on medium screens and up
                                                                            },
                                                                            '& .MuiOutlinedInput-root': {
                                                                                height: '48px',
                                                                                borderRadius: '8px',
                                                                                backgroundColor: '#FFFFFF',
                                                                                border: returnDateError ? '1px solid red' : 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                fontSize: '16px',
                                                                                padding: '0px 14px',
                                                                                color: returnDateError ? 'red' : 'inherit',
                                                                            },
                                                                        }}
                                                                        slotProps={{
                                                                            textField: {
                                                                                fullWidth: true,
                                                                                placeholder: 'Select Time',
                                                                            },
                                                                        }}
                                                                    />
                                                                    {dateTimeError && (
                                                                        <Typography
                                                                            color="error"
                                                                            variant="caption"
                                                                            sx={{ display: 'block', mt: 0.5 }}
                                                                        >
                                                                            {dateTimeError}
                                                                        </Typography>
                                                                    )}
                                                                </DemoContainer>
                                                            </LocalizationProvider>
                                                        </Grid2>
                                                        {/* </Grid2> */}
                                                    </Grid2>

                                                    {/* Vehicle */}
                                                    <Grid2 container sx={{alignItems:'center', marginTop:'2%'}}>
                                                        <Grid2 item size={1.5}>
                                                            <Typography variant="subtitle1"
                                                                sx={{
                                                                    fontWeight: 500, color: "#333",
                                                                    mr: 2,  whiteSpace: 'nowrap', minWidth: '75px'
                                                                }}
                                                            >
                                                                Vehicle
                                                            </Typography>
                                                        </Grid2>
                                                        <Grid2 item size={10.5}>
                                                            <Select fullWidth displayEmpty
                                                                value={newShift.vehicle_id || ''}
                                                                onChange={(e) => handleNewShiftChange('vehicle_id', e.target.value)}
                                                                error={!newShift.vehicle_id && formSubmitted}
                                                                // renderValue={(selected) => {
                                                                //     if (!selected) {
                                                                //         return <span style={{ color: 'rgba(0, 0, 0, 0.6)' }}>Select a vehicle</span>;
                                                                //     }
                                                                //     return selected;
                                                                // }}
                                                                startAdornment={
                                                                    <InputAdornment position="start">
                                                                        <IconButton edge="start" disabled>
                                                                            <img src={DirectionsCarIcon} alt="Vehicle" style={{ width: 20, height: 20 }} />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }
                                                                sx={{
                                                                    width: '100%', height: '48px',
                                                                    '& .MuiOutlinedInput-root': {
                                                                        borderRadius: "12px", height: "48px", backgroundColor: "#fafafa",
                                                                        '& .MuiSelect-select': {
                                                                            padding: '12px 14px', display: 'flex', alignItems: 'center',
                                                                            minHeight: '16px', height: '16px', border: !newShift.vehicle_id && formSubmitted ? '1px solid red' : '1px solid #ccc',
                        
                                                                        },
                                                                    },
                                                                    '& .MuiSelect-icon': {right: '8px',}
                                                                }}
                                                            >
                                                                <MenuItem value="" disabled> Select a vehicle</MenuItem>
                                                                {availableVehicle?.map((vehicle) => (
                                                                    <MenuItem
                                                                        key={vehicle.id}
                                                                        value={vehicle.id}
                                                                        sx={{
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            padding: '8px 16px'
                                                                        }}
                                                                    >
                                                                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                                            {vehicle.brand} {vehicle.model_name}
                                                                        </Typography>
                                                                        <Typography variant="caption" color="textSecondary">
                                                                            {vehicle.vehicle_number}
                                                                        </Typography>
                                                                    </MenuItem>
                                                                ))}

                                                            </Select>
                                                            {!newShift.vehicle_id && formSubmitted && (
                                                                <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                                                                    Please select a vehicle
                                                                </Typography>
                                                            )}
                                                        </Grid2>
                                                    </Grid2>

                                                    {/* Action Buttons */}
                                                    <Box sx={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        width: '100%',
                                                        mt: 1
                                                    }}>
                                                        <Grid2 container spacing={2} sx={{
                                                            maxWidth: '300px', // Adjust this width as needed
                                                            justifyContent: 'center'
                                                        }}>
                                                            <Grid2 item xs={6}>
                                                                <Button
                                                                    fullWidth
                                                                    variant="contained"
                                                                    onClick={handleSaveNewShift}
                                                                    sx={{
                                                                        height: '40px', minWidth: '80px', textTransform: 'none', backgroundColor: '#2563EB', '&:hover': { backgroundColor: '#1D4ED8' }
                                                                    }}
                                                                >
                                                                    Save
                                                                </Button>
                                                            </Grid2>
                                                            <Grid2 item xs={6}>
                                                                <Button
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    onClick={handleCancelAddShift}
                                                                    sx={{
                                                                        height: '40px', minWidth: '80px', textTransform: 'none', color: '#6B7280', borderColor: '#D1D5DB'
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </Grid2>
                                                        </Grid2>
                                                    </Box>
                                                </Grid2>
                                            </Box>
                                        )}

                                        <Button
                                            style={{
                                                width: "100%",
                                                height: "50px",
                                                marginTop: '12px',
                                                // backgroundColor: "#2563EB",
                                                textTransform: "none",
                                                borderRadius: "8px",
                                                color: '#0065FF',
                                                border: '1px solid #2563EB',
                                                marginBottom: "20px"
                                            }}
                                            sx={{
                                                '&.Mui-disabled': {
                                                    color: 'rgba(0, 0, 0, 0.26)',
                                                    borderColor: 'rgba(0, 0, 0, 0.12)'
                                                }
                                            }}
                                            
                                            onClick={() => handleAddNewShift()}
                                            disabled={showAddShiftForm || shiftType === "view"}
                                        >
                                            + Add Shift
                                        </Button>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            width: '100%', // Ensure the Box takes full width to center properly
                                            mt: 0.5, // Match the existing marginTop: '5px'
                                            mb: 5, // Match the existing marginBottom: '40px'
                                        }}
                                    >
                                        <Button
                                            style={{
                                                width: '30%',
                                                height: '50px',
                                                backgroundColor: showAddShiftForm ? '#D1D5DB' : '#2563EB',
                                                textTransform: 'none',
                                                borderRadius: '8px',
                                                color: '#ffffff', // Corrected color code (ffffffff -> ffffff)
                                                justifyContent: 'center', // This affects the button's content (text/icon)
                                                alignItems: 'center', // This affects the button's content
                                            }}
                                            onClick={handleClose}
                                            disabled={showAddShiftForm}
                                        >
                                            Done
                                        </Button>
                                    </Box>
                                </Grid2>

                            </Paper>
                        </div>
                    </Box>
                </div>
            )}

            <Modal open={openModal} onClose={handlemodalClose}>
                <Box sx={Modalstyle}>
                    {/* Header */}
                    <Typography
                        variant="h6"
                        sx={{ fontWeight: 600, textAlign: "center", mb: 1 }}
                    >
                        Edit Shift
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        sx={{ textAlign: "center", color: "text.secondary", mb: 1 }}
                    >
                     {modalEditDetails.start && modalEditDetails.end && modalStartTime && modalEndTime && (
                    <Typography variant="subtitle2" sx={{ textAlign: "center", color: "text.secondary", mb: 1 }}>
                        {new Date(modalEditDetails.start).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })} {" "}
                        {/* [ {dayjs(`${dayjs(modalEditDetails.start).format('YYYY-MM-DD')} ${modalStartTime}`, 'YYYY-MM-DD HH:mm:ss')
                            .format('hh:mm A')} ] - {" "}
                            {new Date(modalEditDetails.end).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })} {" "}
                            [ {dayjs(`${dayjs(modalEditDetails.end).add(utcOffset, 'minute').format('YYYY-MM-DD')} ${modalEndTime}`, 'YYYY-MM-DD HH:mm:ss')
                            .format('hh:mm A')} ] */}
                     </Typography>

                )}
                    </Typography>

                    {/* Upcoming Ride */}
                    {false && <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="center"
                        alignItems="center"
                        sx={{ mb: 3 }}
                    >
                        <Typography variant="body2" color="text.secondary">
                            Upcoming Ride:
                        </Typography>
                        <Chip
                            label="Ride #45678"
                            size="small"
                            variant="outlined"
                            sx={{ fontWeight: 500 }}
                        />
                    </Stack>}

                    <Grid2 container spacing={1} direction="row" sx={{display: "flex", justifyContent: "flex-start", alignItems: "center",marginBottom: "10px",width: "100%"}}>
                    <Grid2 item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']} sx={{ '& .MuiStack-root': { padding: 0, width: '100%' } }}>
                                 <DateTimePicker
                                    label="Start Time"
                                    value={
                                        modalStartTime
                                        }
                                    minDate={modalStartTime}
                                    maxDate={modalStartTime}
                                   onChange={(newValue) => {
                                       setModalStartTime(newValue);
                                   }}
                                    // disabled={shiftType === "view"}
                                    sx={{
                                        width: '100%',
                                        '& .MuiOutlinedInput-root': { height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF', border: returnDateError ? '1px solid red' : 'none' },
                                        '& .MuiInputBase-input': { fontSize: '16px', padding: '0px 14px', color: returnDateError ? 'red' : 'inherit' },
                                    }}
                                    slotProps={{ textField: { fullWidth: true, placeholder: 'Select time' } }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                        </Grid2>
                        <Grid2 item xs={12} sm={6} >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']} sx={{ '& .MuiStack-root': { padding: 0 ,width: '100%'} }}>
                                <DateTimePicker
                                    label="End Time"
                                    value={
                                        modalEndTime
                                        }

                                    onChange={(newValue) => {
                                        setModalEndTime(newValue);
                                    }}
                                    minDate={dayjs(mainselectedDate)}
                                    maxDate={dayjs(mainselectedDate).add(1,'day')}
                                    // disabled={shiftType === "view"}
                                    sx={{
                                        width: '100%',
                                        '& .MuiOutlinedInput-root': { height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF', border: returnDateError ? '1px solid red' : 'none' },
                                        '& .MuiInputBase-input': { fontSize: '16px', padding: '0px 14px', color: returnDateError ? 'red' : 'inherit' },
                                    }}
                                    slotProps={{ textField: { fullWidth: true, placeholder: 'Select time' } }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                        </Grid2>
                        </Grid2>

                    {/* Current Driver */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            background: '#F3F8FF',
                            mb: 1.5,
                            p: 1,
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '1rem',
                                color: '#6B7280',
                                minWidth: '120px'
                            }}
                        >
                            Current Driver:
                        </Typography>
                        <TextField
                            value={modalDriverDetails?.driver_name}
                            disabled
                            size="small"
                            variant="standard"
                            fullWidth
                            InputProps={{
                                disableUnderline: true,
                                style: {
                                    textAlign: 'right',
                                    paddingRight: '8px',
                                    backgroundColor: 'transparent'
                                }
                            }}
                            sx={{
                                '& .MuiInputBase-input': {
                                    textAlign: 'right',
                                    color: 'text.primary',
                                    py: 0.5
                                }
                            }}
                        />
                    </Box>


                    <FormControl fullWidth size="small" sx={{ mb: 4 }}>
                        <InputLabel>Choose New Driver</InputLabel>
                        <Select
                            value={modalDriver?.driver_id || ""}
                            onChange={(e) => {
                                const selectedDriver = driversData.find(
                                    (v) => v.driver_id === e.target.value
                                );
                                setModalDriver(selectedDriver);
                            }}
                            label="Choose New Driver"
                            renderValue={(selectedId) => {
                                if (!selectedId) return "Select a driver";
                                const selected = driversData.find((v) => v.driver_id === selectedId);
                                return selected
                                    ? `${selected.driver_name} (${selected.phone_number})`
                                    : "Select a driver";
                            }}
                            sx={{ color: "#6B7280" }}
                        >
                            {driversData?.map((driver) => (
                                <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                    <Box>
                                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                            {driver.driver_name}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            {driver.phone_number}
                                        </Typography>
                                    </Box>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* Current Vehicle */}

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            background: '#F3F8FF',
                            mb: 1.5,
                            p: 1,
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '1rem',
                                color: '#6B7280',
                                minWidth: '120px'
                            }}
                        >
                            Current Vehicle:
                        </Typography>
                        <TextField
                            value={modalEditDetails.vehicle_number}
                            disabled
                            size="small"
                            variant="standard"
                            fullWidth
                            InputProps={{
                                disableUnderline: true,
                                style: {
                                    textAlign: 'right',
                                    paddingRight: '8px',
                                    backgroundColor: 'transparent'
                                }
                            }}
                            sx={{
                                '& .MuiInputBase-input': {
                                    textAlign: 'right',
                                    color: 'text.primary',
                                    py: 0.5
                                }
                            }}
                        />
                    </Box>

                    {/* Choose New Vehicle */}
                    <FormControl fullWidth size="small" sx={{ mb: 4 }}>
                        <InputLabel>Choose New Vehicle</InputLabel>
                        <Select
                            value={modalVehicle?.id || ""}
                            onChange={(e) => {
                                const selectedVehicle = availableVehicle.find(
                                    (v) => v.id === e.target.value
                                );
                                setModalVehicle(selectedVehicle);
                            }}
                            label="Choose New Vehicle"
                            renderValue={(selectedId) => {
                                if (!selectedId) return "Select a vehicle";
                                const selected = availableVehicle.find((v) => v.id === selectedId);
                                return selected
                                    ? `${selected.brand} ${selected.model_name} (${selected.vehicle_number})`
                                    : "Select a vehicle";
                            }}
                            sx={{ color: "#6B7280" }}
                        >
                            {availableVehicle?.map((vehicle) => (
                                <MenuItem key={vehicle.id} value={vehicle.id}>
                                    <Box>
                                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                            {vehicle.brand} {vehicle.model_name}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            {vehicle.vehicle_number}
                                        </Typography>
                                    </Box>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                    {/* Action Buttons */}
                    <Stack direction="row" spacing={2} justifyContent="space-between">
                        <Button
                            variant="outlined"
                            fullWidth
                            onClick={handlemodalClose}
                            sx={{
                                borderColor: "#0065FF",
                                color: "#0065FF",
                                "&:hover": { borderColor: "#0065FF" },
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            onClick={() => handleSubmit(modalEditDetails)}
                            sx={{
                                bgcolor: "#0065FF",
                                "&:hover": { bgcolor: "#1e4ed8" },
                            }}
                        >
                            Update Shift
                        </Button>
                    </Stack>
                </Box>
            </Modal>
            <Snackbar
                open={snackbar}
                autoHideDuration={2000}
                onClose={handleSnackbarClose}
                message={message}
            />
            <Dialog
                open={openDeleteConfirmModal}
                onClose={() => setOpenDeleteConfirmModal(false)}
                aria-labelledby="delete-booking-dialog-title"
                aria-describedby="delete-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="delete-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-booking-dialog-description">
                        Are you sure you want to delete this Shift permanently?
                        <br/> This cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={handleDeleteConfirmModalClose} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            handleDeleteshift(deletingShiftId);
                            // setOpenDeleteConfirmModal(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={singleShiftModal}
                onClose={() => setSingleShiftModal(false)}
                aria-labelledby="delete-booking-dialog-title"
                aria-describedby="delete-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="delete-booking-dialog-title" sx={{fontWeight:'bold'}}>Ride Details</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-booking-dialog-description">
                    {ShiftRideDetails?.length === 0 ? (
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            No rides found for this shift.
                        </Typography>
                    ) : (
                        ShiftRideDetails?.map((ride, index) => (
                            <AccordionDetails key={ride.ride_id} sx={{ p: 0 }}>
                                <Box
                                    sx={{
                                        borderRadius: "12px",
                                    backgroundColor: "#f9f9f9",
                                    p: 2,
                                    mb: 2,
                                }}
                            >
                                {/* Ride ID + Title */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >
                                    <Typography variant="h6" sx={{ fontWeight: 400 }}>
                                        {ride.status === 2 ? "Assigned" : ride.status === 3 ? "Arrived" : ride.status === 5 ? "Started" : "Ride"}
                                    </Typography>
                                        <Box sx={{ display: 'flex', gap: 2 }}>
                                        {ride.ride_id &&
                                        <Typography
                                            sx={{
                                                color: "#2962ff",
                                                border: "1px solid #2962ff",
                                                borderRadius: "8px",
                                                px: 1.5,
                                                py: 0.5,
                                                fontWeight: 500,
                                                fontSize: "14px",
                                            }}
                                        >
                                            Ride ID : {ride.ride_id}
                                        </Typography>}
                                        <Typography
                                            sx={{
                                                color: "#2962ff",
                                                border: "1px solid #2962ff",
                                                borderRadius: "8px",
                                                px: 1.5,
                                                py: 0.5,
                                                fontWeight: 500,
                                                fontSize: "14px",
                                            }}
                                        >
                                            Engagement ID : {ride.engagement_id}
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Pickup and Drop */}
                                <Box
                                    sx={{
                                        backgroundColor: "#fff",
                                        borderRadius: "12px",
                                        p: 2,
                                        mb: 2,
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                        <img src={PickUpIcon} alt="Pickup" height={20} width={20} />
                                        <Typography variant="body1" sx={{ fontWeight: 400, ml: 1 }}>
                                            {ride.pickup_address || 'N/A'}
                                        </Typography>
                                        {ride.pickup_time && (
                                            <Box sx={{ ml: "auto", backgroundColor: "#f4f4f4", px: 1.5, py: 0.5, borderRadius: "8px" }}>
                                                <Typography sx={{ fontWeight: 400 }}>
                                                {new Date(ride.pickup_time).toLocaleTimeString('en-US', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                })}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                    
                                    <Divider sx={{ borderStyle: "dashed", my: 1, ml: 3 }} />

                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <img src={DropIcon} alt="Drop" height={20} width={20} />
                                        <Typography variant="body1" sx={{ fontWeight: 400, ml: 1 }}>
                                            {ride.drop_address || 'N/A'}
                                        </Typography>
                                        {ride.drop_time && (
                                            <Box sx={{ ml: "auto", backgroundColor: "#f4f4f4", px: 1.5, py: 0.5, borderRadius: "8px" }}>
                                                <Typography sx={{ fontWeight: 400 }}>
                                                    {new Date(ride.drop_time).toLocaleTimeString('en-US', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                })}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>

                                {/* Vehicle Info */}
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <img src={BlueCarIcon} alt="Vehicle" height={60} width={60} />
                                    <Box>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 500, ml: 1, color: "#4E545D" }}>
                                            {ride.vehicle_number || 'N/A'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                                            {VehicleTypes[ride.vehicle_type]}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </AccordionDetails>
                    )))}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => {
                            handleViewModalClose();
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openOverWriteModal}
                onClose={() => setOpenOverWriteModal(false)}
                aria-labelledby="delete-booking-dialog-title"
                aria-describedby="delete-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="delete-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-booking-dialog-description">
                    System already has shifts for this date
                        <br/> Do You want to OverWrite it .
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={handleOverWriteModalapprove} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        Yes
                    </Button>
                    <Button 
                        onClick={() => {
                            handleOverWriteModalreject();
                            // setOpenDeleteConfirmModal(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Edit Existing
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showPasteDialog}
                onClose={handlePasteCancel}
                aria-labelledby="paste-dialog-title"
            >
                <DialogContent>
                    <DialogContentText>
                        Do you want to paste the copied shift data of {mainselectedDate?.format('DD/MM/YYYY')} to {pasteDate?.format('DD/MM/YYYY')}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePasteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handlePasteConfirm} color="error"
                                    variant="contained"
                                    sx={{ 
                                        backgroundColor: '#EF4444', 
                                        borderRadius:'8px', 
                                        textTransform:'none',
                                        '&:hover': {
                                            backgroundColor: '#DC2626'
                                        }
                                    }}
                             autoFocus>
                        Paste
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={errorDialog}
                onClose={handleerrordialogeClose}
                aria-labelledby="paste-dialog-title"
            >
                <DialogTitle id="paste-dialog-title" sx={{ fontSize: '16px', fontWeight: 600 }}>Paste Shift Data</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {errordialogeMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleerrordialogeClose} color="error"
                                    variant="contained"
                                    sx={{ 
                                        backgroundColor: '#EF4444', 
                                        borderRadius:'8px', 
                                        textTransform:'none',
                                        '&:hover': {
                                            backgroundColor: '#DC2626'
                                        }
                                    }}
                             autoFocus>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ShiftTiming;
